import React, { useState, useEffect, useCallback } from 'react';
import { FaUsers, FaBuilding, FaSearch, FaEdit, FaTrash, FaChartBar, FaGift, FaFileAlt, FaMoneyCheckAlt, FaGraduationCap, FaHistory, FaCheckCircle, FaBell, FaTimes, FaDownload, FaLock, FaEye, FaEyeSlash, FaUser } from 'react-icons/fa';
import AdminAttendanceReport from './AdminAttendanceReport';
import AdminRewardsDashboard from './AdminRewardsDashboard';
import AdminGamingReport from './AdminGamingReport';
import AdminReferralReport from './AdminReferralReport';
import AdminReferredCandidatesStipendReport from './AdminReferredCandidatesStipendReport';
import AdminSPOCReport from './AdminSPOCReport';
import AdminSPOCUploadStatusReport from './AdminSPOCUploadStatusReport';
import AdminCourseManagement from './AdminCourseManagement';
import DownloadZipButton from './DownloadZipButton';
import AdminQuizDashboard from './AdminQuizDashboard';
import AdminSalaryAdvanceDashboard from './AdminSalaryAdvanceDashboard';
import AdminHigherEducationDashboard from './AdminHigherEducationDashboard';
import AdminRetentionReport from './AdminRetentionReport';
import AdminAssessmentDueReport from './AdminAssessmentDueReport';
import AdminCompanyReports from './AdminCompanyReports';
import AdminAttritionReport from './AdminAttritionReport';
import AdminWorkDiaryDashboard from './AdminWorkDiaryDashboard';
import AdminDocumentApi from './AdminDocumentApi';
import { Tabs, Tab } from '@mui/material';
import { toast, Toaster } from 'react-hot-toast';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';
const ITEMS_PER_PAGE = 10;

// Custom Company Dropdown Component with search
const CompanyDropdown = ({ companies, value, onChange, placeholder = "Select Company" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const selectedCompany = companies.find(c => c.id === parseInt(value));

  const filteredCompanies = companies.filter(company =>
    company.company_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (company.establishment_code && company.establishment_code.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (company.email && company.email.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const handleSelect = (company) => {
    onChange({ target: { value: company.id.toString() } });
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: '100%',
          borderRadius: 8,
          padding: '12px 16px',
          fontSize: 16,
          border: '2px solid #e1e5e9',
          background: '#fff',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          transition: 'border-color 0.3s ease',
          minHeight: '44px',
          boxSizing: 'border-box'
        }}
        onMouseEnter={(e) => e.target.style.borderColor = '#22c55e'}
        onMouseLeave={(e) => e.target.style.borderColor = isOpen ? '#22c55e' : '#e1e5e9'}
      >
        <span style={{ 
          color: selectedCompany ? '#333' : '#999',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1
        }}>
          {selectedCompany 
            ? `${selectedCompany.company_name}${selectedCompany.establishment_code ? ` (${selectedCompany.establishment_code})` : ''}`
            : placeholder
          }
        </span>
        <span style={{ 
          color: '#666',
          fontSize: 12,
          marginLeft: 8,
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease'
        }}>
          ▼
        </span>
      </div>

      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          zIndex: 1000,
          background: '#fff',
          border: '2px solid #22c55e',
          borderRadius: 8,
          boxShadow: '0 8px 32px rgba(34, 197, 94, 0.15)',
          overflow: 'hidden',
          marginTop: 4
        }}>
          {/* Search Bar inside dropdown */}
          <div style={{
            padding: '12px 16px',
            borderBottom: '1px solid #e0f7fa',
            background: '#f8fafc'
          }}>
            <div style={{ position: 'relative' }}>
              <FaSearch style={{
                position: 'absolute',
                left: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#22c55e',
                fontSize: 14
              }} />
              <input
                type="text"
                placeholder="Search companies..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px 12px 8px 36px',
                  border: '1px solid #e0f7fa',
                  borderRadius: 8,
                  fontSize: 14,
                  outline: 'none',
                  background: '#fff'
                }}
                onClick={(e) => e.stopPropagation()}
                onFocus={(e) => e.target.style.borderColor = '#22c55e'}
                onBlur={(e) => e.target.style.borderColor = '#e0f7fa'}
              />
            </div>
          </div>

          {/* Scrollable Results List */}
          <div style={{
            maxHeight: '300px',
            overflowY: 'auto',
            background: '#fff'
          }}>
            {filteredCompanies.length === 0 ? (
              <div style={{
                padding: '20px',
                textAlign: 'center',
                color: '#666',
                fontSize: 14
              }}>
                No companies found
              </div>
            ) : (
              filteredCompanies.map((company, index) => (
                <div
                  key={company.id}
                  onClick={() => handleSelect(company)}
                  style={{
                    padding: '12px 16px',
                    cursor: 'pointer',
                    borderBottom: index < filteredCompanies.length - 1 ? '1px solid #f0f0f0' : 'none',
                    transition: 'background-color 0.2s ease',
                    backgroundColor: selectedCompany && selectedCompany.id === company.id ? '#f0f9ff' : '#fff'
                  }}
                  onMouseEnter={(e) => {
                    if (!selectedCompany || selectedCompany.id !== company.id) {
                      e.target.style.background = '#f0f9ff';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!selectedCompany || selectedCompany.id !== company.id) {
                      e.target.style.background = '#fff';
                    }
                  }}
                >
                  <div style={{
                    fontWeight: 600,
                    color: '#333',
                    fontSize: 14,
                    marginBottom: 4
                  }}>
                    {company.company_name}
                  </div>
                  {company.establishment_code && (
                    <div style={{
                      color: '#22c55e',
                      fontSize: 12,
                      marginBottom: 2
                    }}>
                      {company.establishment_code}
                    </div>
                  )}
                  {company.email && (
                    <div style={{
                      color: '#999',
                      fontSize: 12,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      {company.email}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>

          {/* Footer with count */}
          <div style={{
            padding: '8px 16px',
            background: '#f8fafc',
            borderTop: '1px solid #e0f7fa',
            fontSize: 12,
            color: '#666',
            textAlign: 'center'
          }}>
            {filteredCompanies.length} of {companies.length} companies
          </div>
        </div>
      )}

      {/* Click outside to close */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => {
            setIsOpen(false);
            setSearchTerm('');
          }}
        />
      )}
    </div>
  );
};

// Custom Establishment Dropdown Component
const EstablishmentDropdown = ({ establishments, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedEstablishment, setSelectedEstablishment] = useState(null);

  const filteredEstablishments = establishments.filter(establishment =>
    establishment.establishmentId.toLowerCase().includes(searchTerm.toLowerCase()) ||
    establishment.companyName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (establishment) => {
    setSelectedEstablishment(establishment);
    onSelect(establishment.establishmentId, establishment);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: '100%',
          borderRadius: 16,
          padding: '10px 16px',
          fontSize: 16,
          border: '1.5px solid #e0f7fa',
          background: '#f8fafc',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          transition: 'border-color 0.2s ease',
          minHeight: '44px'
        }}
        onMouseEnter={(e) => e.target.style.borderColor = '#22c55e'}
        onMouseLeave={(e) => e.target.style.borderColor = '#e0f7fa'}
      >
        <span style={{ 
          color: selectedEstablishment ? '#333' : '#999',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }}>
          {selectedEstablishment 
            ? `${selectedEstablishment.establishmentId} - ${selectedEstablishment.companyName}`
            : 'Select Establishment ID'
          }
        </span>
        <FaSearch style={{ 
          color: '#22c55e', 
          fontSize: 14,
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease'
        }} />
      </div>

      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          zIndex: 1000,
          background: '#fff',
          border: '1.5px solid #e0f7fa',
          borderRadius: 16,
          boxShadow: '0 8px 32px rgba(34, 197, 94, 0.15)',
          overflow: 'hidden',
          marginTop: 4
        }}>
          {/* Search Bar */}
          <div style={{
            padding: '12px 16px',
            borderBottom: '1px solid #e0f7fa',
            background: '#f8fafc'
          }}>
            <div style={{ position: 'relative' }}>
              <FaSearch style={{
                position: 'absolute',
                left: 12,
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#22c55e',
                fontSize: 14
              }} />
              <input
                type="text"
                placeholder="Search establishment ID or company name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px 12px 8px 36px',
                  border: '1px solid #e0f7fa',
                  borderRadius: 8,
                  fontSize: 14,
                  outline: 'none',
                  background: '#fff'
                }}
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>

          {/* Results List */}
          <div style={{
            maxHeight: '300px',
            overflowY: 'auto',
            background: '#fff'
          }}>
            {filteredEstablishments.length === 0 ? (
              <div style={{
                padding: '20px',
                textAlign: 'center',
                color: '#666',
                fontSize: 14
              }}>
                No establishments found
              </div>
            ) : (
              filteredEstablishments.map((establishment, index) => (
                <div
                  key={establishment.establishmentId}
                  onClick={() => handleSelect(establishment)}
                  style={{
                    padding: '12px 16px',
                    cursor: 'pointer',
                    borderBottom: index < filteredEstablishments.length - 1 ? '1px solid #f0f0f0' : 'none',
                    transition: 'background-color 0.2s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                  }}
                  onMouseEnter={(e) => e.target.style.background = '#f0f9ff'}
                  onMouseLeave={(e) => e.target.style.background = '#fff'}
                >
                  <div style={{
                    fontWeight: 600,
                    color: '#22c55e',
                    fontSize: 14
                  }}>
                    {establishment.establishmentId}
                  </div>
                  <div style={{
                    color: '#666',
                    fontSize: 13,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}>
                    {establishment.companyName}
                  </div>
                  <div style={{
                    color: '#999',
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                  }}>
                    <FaSearch style={{ fontSize: 10 }} />
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {establishment.email}
                    </span>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Footer */}
          <div style={{
            padding: '8px 16px',
            background: '#f8fafc',
            borderTop: '1px solid #e0f7fa',
            fontSize: 12,
            color: '#666',
            textAlign: 'center'
          }}>
            {filteredEstablishments.length} establishment{filteredEstablishments.length !== 1 ? 's' : ''} found
          </div>
        </div>
      )}

      {/* Click outside to close */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

// Helper to get valid admin access token, refresh if needed
export async function getAdminAccessToken() {
  let accessToken = localStorage.getItem('gogig_admin_access');
  const refreshToken = localStorage.getItem('gogig_admin_refresh');
  // Try a test request to check if token is valid
  if (accessToken) {
    try {
      const res = await fetch(`${API_URL}/api/admin/stats`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });
      if (res.status !== 401) return accessToken;
    } catch {}
  }
  // Try to refresh
  if (refreshToken) {
    try {
      const res = await fetch(`${API_URL}/api/admin/refresh-token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken })
      });
      const data = await res.json();
      if (data.success && data.accessToken) {
        localStorage.setItem('gogig_admin_access', data.accessToken);
        return data.accessToken;
      }
    } catch {}
  }
  // Clear tokens and redirect to login instead of reloading
  localStorage.removeItem('gogig_admin_access');
  localStorage.removeItem('gogig_admin_refresh');
  window.location.href = '/admin'; // Redirect to admin login page
  return null;
}

// Helper for authenticated fetch
export async function adminFetch(url, options = {}) {
  const token = await getAdminAccessToken();
  if (!token) throw new Error('Not authenticated');
  const headers = { ...(options.headers || {}), Authorization: `Bearer ${token}` };
  return fetch(url, { ...options, headers });
}

function AdminDashboard({ onLogout, onQuiz }) {
  const [isAuthenticated, setIsAuthenticated] = useState(() => !!(localStorage.getItem('gogig_admin_access') || localStorage.getItem('gogig_admin_refresh')));
  const [stats, setStats] = useState({ candidates: 0, companies: 0, institutions: 0 });
  const [tab, setTab] = useState('candidates'); // candidates | companies | supervisors | institutions | attendanceReport | rewards | referralReport | spocReport | spocUploadStatus | documents | salaryAdvance | retentionReport
  const [candidates, setCandidates] = useState([]);
  const [unregisteredCandidates, setUnregisteredCandidates] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [showInstitutionForm, setShowInstitutionForm] = useState(false);
  const [institutionForm, setInstitutionForm] = useState({
    name: '',
    email: '',
    password: '',
    contact_person: '',
    contact_mobile: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    website: '',
    rating: 0
  });
  
  // Course Management States
  const [courses, setCourses] = useState([]);
  const [showCourseForm, setShowCourseForm] = useState(false);
  const [selectedInstitution, setSelectedInstitution] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedItemDetails, setSelectedItemDetails] = useState(null);

  const handleShowDetails = (item) => {
    setSelectedItemDetails(item);
    setShowDetailsModal(true);
  };
  const [courseForm, setCourseForm] = useState({
    course_name: '',
    trade_code: '',
    duration_months: '',
    total_seats: '',
    course_description: '',
    eligibility_criteria: ''
  });
  
  // Student Management States
  const [students, setStudents] = useState([]);
  const [showStudentForm, setShowStudentForm] = useState(false);
  const [studentForm, setStudentForm] = useState({
    course_id: '',
    student_name: '',
    roll_number: '',
    email: '',
    mobile: '',
    gender: '',
    date_of_birth: '',
    father_name: '',
    mother_name: '',
    address: '',
    admission_date: '',
    expected_completion_date: ''
  });
  
  // Campus Visit Management States
  const [campusVisits, setCampusVisits] = useState([]);
  const [showCampusVisitForm, setShowCampusVisitForm] = useState(false);
  const [campusVisitForm, setCampusVisitForm] = useState({
    visit_date: '',
    visit_purpose: '',
    company_name: '',
    contact_person: '',
    contact_mobile: '',
    visit_status: 'scheduled',
    notes: ''
  });
  
  // Management View States
  const [institutionManagementView, setInstitutionManagementView] = useState('overview'); // overview, courses, students, campus_visits
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [listTotal, setListTotal] = useState(0);
  const [listTotalPages, setListTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [editForm, setEditForm] = useState({
    name: '',
    email: '',
    mobile: '',
    password: ''
  });
  const [csvHistory, setCsvHistory] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(null);
  const [docImportTab, setDocImportTab] = useState('naps');
  const [activeTab, setActiveTab] = useState('candidates');
  const [offerLetters, setOfferLetters] = useState([]);
  const [offerLetterTab, setOfferLetterTab] = useState('list'); // list | create | bulk
  const [candidateSearch, setCandidateSearch] = useState('');
  const [candidateResults, setCandidateResults] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [offerForm, setOfferForm] = useState({
    name: '', so_name: '', address: '', company_name: '', designation: '', location: '', compensation: {},
    mobile: '', registration_no: '', program_name: '', offer_letter_format: 'timex'
  });
  const [offerStatus, setOfferStatus] = useState('');
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkStatus, setBulkStatus] = useState('');
  const [bulkLoading, setBulkLoading] = useState(false);
  const [stipendReportYear, setStipendReportYear] = useState(new Date().getFullYear());
  const [stipendReportMonth, setStipendReportMonth] = useState(new Date().getMonth() + 1);
  
  // Add new state variables for sales invoice integration
  const [invoiceSearch, setInvoiceSearch] = useState('');
  const [invoiceList, setInvoiceList] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  
  // Add state for company name input
  const [companyNameInput, setCompanyNameInput] = useState('');
  
  // Add state for document type selection
  const [selectedDocumentType, setSelectedDocumentType] = useState('');
  
  // Add state for NAPS establishment IDs
  const [napsEstablishmentIds, setNapsEstablishmentIds] = useState([]);
  
  // Add state for BVOC establishment IDs
  const [bvocEstablishmentIds, setBvocEstablishmentIds] = useState([]);

  // Add state for NATS establishment IDs
  const [natsEstablishmentIds, setNatsEstablishmentIds] = useState([]);
  
  // Add state for selected establishment (code + company name for capture on stipend upload)
  const [selectedEstablishmentCode, setSelectedEstablishmentCode] = useState('');
  const [selectedEstablishmentCompanyName, setSelectedEstablishmentCompanyName] = useState('');

  // Add notifications state
  const [notifications, setNotifications] = useState([]);
  const [notificationForm, setNotificationForm] = useState({
    title: '',
    message: '',
    type: 'general',
    target_audience: 'all',
    image: null
  });
  const [showNotificationForm, setShowNotificationForm] = useState(false);
  const [editingNotification, setEditingNotification] = useState(null);
  const [notificationLoading, setNotificationLoading] = useState(false);

  // Add state for jobs and applicants modal
  const [jobs, setJobs] = useState([]);
  const [showApplicantsModal, setShowApplicantsModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [jobApplicants, setJobApplicants] = useState([]);
  
  // Supervisor management state
  const [supervisors, setSupervisors] = useState([]);
  const [supervisorForm, setSupervisorForm] = useState({
    name: '',
    email: '',
    mobile: '',
    password: '',
    role: 'supervisor',
    permissions: {},
    spoc_id: '',
    company_id: ''
  });
  const [showSupervisorForm, setShowSupervisorForm] = useState(false);
  const [editingSupervisor, setEditingSupervisor] = useState(null);
  const [resetPasswordSupervisor, setResetPasswordSupervisor] = useState(null);
  const [resetPasswordNew, setResetPasswordNew] = useState('');
  const [resetPasswordConfirm, setResetPasswordConfirm] = useState('');
  const [showResetPasswordNew, setShowResetPasswordNew] = useState(false);
  const [showResetPasswordConfirm, setShowResetPasswordConfirm] = useState(false);

  // SPOC management state
  const [spocs, setSpocs] = useState([]);
  const [showSPOCForm, setShowSPOCForm] = useState(false);
  const [editingSPOC, setEditingSPOC] = useState(null);
  const [spocForm, setSpocForm] = useState({
    name: '',
    email: '',
    password: '',
    company_ids: []
  });
  const [spocCompanySearch, setSpocCompanySearch] = useState('');

  // Supervisor list pagination
  const [supervisorPage, setSupervisorPage] = useState(1);
  const [supervisorTotal, setSupervisorTotal] = useState(0);
  const [supervisorTotalPages, setSupervisorTotalPages] = useState(1);
  const [supervisorSearch, setSupervisorSearch] = useState('');
  const SUPERVISOR_PAGE_SIZE = 10;

  // SPOC list pagination (for SPOC tab)
  const [spocPage, setSpocPage] = useState(1);
  const [spocTotal, setSpocTotal] = useState(0);
  const [spocTotalPages, setSpocTotalPages] = useState(1);
  const [spocSearch, setSpocSearch] = useState('');
  const [spocsForDropdown, setSpocsForDropdown] = useState([]); // All SPOCs for supervisor form dropdown
  const SPOC_PAGE_SIZE = 10;

  useEffect(() => {
    if (!isAuthenticated) return;
    fetchStats();
    if (tab === 'candidates') {
      fetchCandidates();
    }
    else if (tab === 'unregistered') {
      fetchUnregisteredCandidates();
    }
    else if (tab === 'companies') fetchCompanies();
    else if (tab === 'institutions') fetchInstitutions();
    else     if (tab === 'documents') fetchCsvHistory();
    if (tab === 'documents' && docImportTab === 'salaried') fetchOfferLetters();
    if (tab === 'notifications') fetchNotifications();
    if (tab === 'jobs') fetchJobs();
    if (tab === 'supervisors') {
      fetchSupervisors();
      fetchSpocsForDropdown(); // All SPOCs for supervisor form dropdown
      fetchAllCompaniesForSupervisor(); // Fetch ALL companies (no pagination) for supervisor dropdown
    }
    if (tab === 'spocs') fetchSPOCs();
  }, [tab, currentPage, isAuthenticated, docImportTab, supervisorPage, spocPage]);

  const fetchStats = async () => {
    const res = await adminFetch(`${API_URL}/api/admin/stats`);
    const data = await res.json();
    if (data.success) setStats(data.stats);
  };

  const fetchCandidates = async () => {
    setLoading(true);
    const params = new URLSearchParams({
      page: currentPage.toString(),
      limit: ITEMS_PER_PAGE.toString(),
      search: search
    });
    const res = await adminFetch(`${API_URL}/api/admin/candidates?${params}`);
    const data = await res.json();
    if (data.success) {
      setCandidates(data.candidates);
      setListTotal(data.total ?? 0);
      setListTotalPages(data.totalPages ?? 1);
    }
    setLoading(false);
  };

  const fetchUnregisteredCandidates = async () => {
    setLoading(true);
    const params = new URLSearchParams({
      page: currentPage.toString(),
      limit: ITEMS_PER_PAGE.toString(),
      search: search
    });

    const res = await adminFetch(`${API_URL}/api/admin/unregistered-candidates?${params}`);
    const data = await res.json();
    if (data.success) {
      setUnregisteredCandidates(data.candidates);
      setListTotal(data.total ?? 0);
      setListTotalPages(data.totalPages ?? 1);
    }
    setLoading(false);
  };

  const fetchCompanies = async () => {
    setLoading(true);
    const res = await adminFetch(`${API_URL}/api/admin/companies?page=${currentPage}&limit=${ITEMS_PER_PAGE}&search=${search}`);
    const data = await res.json();
    if (data.success) {
      setCompanies(data.companies);
      setListTotal(data.total ?? 0);
      setListTotalPages(data.totalPages ?? 1);
    }
    setLoading(false);
  };

  // Fetch ALL companies for supervisor form (no pagination, includes both BVOC and NAPS)
  const fetchAllCompaniesForSupervisor = async () => {
    try {
      // Fetch all companies with a high limit (or fetch without limit if backend supports it)
      const res = await adminFetch(`${API_URL}/api/admin/companies?page=1&limit=10000&search=`);
      const data = await res.json();
      if (data.success) {
        // Set all companies for supervisor dropdown (both BVOC and NAPS)
        setCompanies(data.companies);
      }
    } catch (error) {
      console.error('Error fetching companies for supervisor:', error);
      toast.error('Failed to fetch companies');
    }
  };

  const fetchInstitutions = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: currentPage,
        limit: ITEMS_PER_PAGE,
        search: search
      });
      const res = await adminFetch(`${API_URL}/api/admin/institutions?${params}`);
      const data = await res.json();
      if (data.success) {
        setInstitutions(data.institutions);
        setListTotal(data.total ?? 0);
        setListTotalPages(data.totalPages ?? 1);
      }
    } catch (error) {
      console.error('Error fetching institutions:', error);
      toast.error('Failed to fetch institutions');
    } finally {
      setLoading(false);
    }
  };

  // Course Management Functions
  const fetchCourses = async (institutionId) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: currentPage,
        limit: ITEMS_PER_PAGE,
        search: search
      });
      const res = await adminFetch(`${API_URL}/api/admin/institutions/${institutionId}/courses?${params}`);
      const data = await res.json();
      if (data.success) setCourses(data.courses);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
    setLoading(false);
  };

  const handleCreateCourse = async (e) => {
    e.preventDefault();
    try {
      const res = await adminFetch(`${API_URL}/api/admin/institutions/${selectedInstitution.id}/courses`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(courseForm)
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Course created successfully!');
        setShowCourseForm(false);
        setCourseForm({
          course_name: '',
          trade_code: '',
          duration_months: '',
          total_seats: '',
          course_description: '',
          eligibility_criteria: ''
        });
        fetchCourses(selectedInstitution.id);
      } else {
        toast.error(data.message || 'Failed to create course');
      }
    } catch (error) {
      console.error('Error creating course:', error);
      toast.error('Failed to create course');
    }
  };

  // Student Management Functions
  const fetchStudents = async (institutionId) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: currentPage,
        limit: ITEMS_PER_PAGE,
        search: search
      });
      const res = await adminFetch(`${API_URL}/api/admin/institutions/${institutionId}/students?${params}`);
      const data = await res.json();
      if (data.success) setStudents(data.students);
    } catch (error) {
      console.error('Error fetching students:', error);
    }
    setLoading(false);
  };

  const handleCreateStudent = async (e) => {
    e.preventDefault();
    try {
      const res = await adminFetch(`${API_URL}/api/admin/institutions/${selectedInstitution.id}/students`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(studentForm)
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Student created successfully!');
        setShowStudentForm(false);
        setStudentForm({
          course_id: '',
          student_name: '',
          roll_number: '',
          email: '',
          mobile: '',
          gender: '',
          date_of_birth: '',
          father_name: '',
          mother_name: '',
          address: '',
          admission_date: '',
          expected_completion_date: ''
        });
        fetchStudents(selectedInstitution.id);
      } else {
        toast.error(data.message || 'Failed to create student');
      }
    } catch (error) {
      console.error('Error creating student:', error);
      toast.error('Failed to create student');
    }
  };

  // Campus Visit Management Functions
  const fetchCampusVisits = async (institutionId) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: currentPage,
        limit: ITEMS_PER_PAGE,
        search: search
      });
      const res = await adminFetch(`${API_URL}/api/admin/institutions/${institutionId}/campus-visits?${params}`);
      const data = await res.json();
      if (data.success) setCampusVisits(data.campusVisits);
    } catch (error) {
      console.error('Error fetching campus visits:', error);
    }
    setLoading(false);
  };

  const handleCreateCampusVisit = async (e) => {
    e.preventDefault();
    try {
      const res = await adminFetch(`${API_URL}/api/admin/institutions/${selectedInstitution.id}/campus-visits`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(campusVisitForm)
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Campus visit scheduled successfully!');
        setShowCampusVisitForm(false);
        setCampusVisitForm({
          visit_date: '',
          visit_purpose: '',
          company_name: '',
          contact_person: '',
          contact_mobile: '',
          visit_status: 'scheduled',
          notes: ''
        });
        fetchCampusVisits(selectedInstitution.id);
      } else {
        toast.error(data.message || 'Failed to schedule campus visit');
      }
    } catch (error) {
      console.error('Error creating campus visit:', error);
      toast.error('Failed to schedule campus visit');
    }
  };

  // Institution Management Functions
  const handleInstitutionSelect = (institution) => {
    setSelectedInstitution(institution);
    setInstitutionManagementView('overview');
    setCurrentPage(1);
    setSearch('');
  };

  const handleManagementViewChange = (view) => {
    setInstitutionManagementView(view);
    setCurrentPage(1);
    setSearch('');
    
    if (selectedInstitution) {
      switch (view) {
        case 'courses':
          fetchCourses(selectedInstitution.id);
          break;
        case 'students':
          fetchStudents(selectedInstitution.id);
          break;
        case 'campus_visits':
          fetchCampusVisits(selectedInstitution.id);
          break;
        default:
          break;
      }
    }
  };

  const handleCreateInstitution = async (e) => {
    e.preventDefault();
    try {
      const res = await adminFetch(`${API_URL}/api/admin/institutions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(institutionForm)
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Institution created successfully!');
        setShowInstitutionForm(false);
        setInstitutionForm({
          name: '',
          email: '',
          password: '',
          contact_person: '',
          contact_mobile: '',
          address: '',
          city: '',
          state: '',
          pincode: '',
          website: '',
          rating: 0
        });
        fetchInstitutions();
        fetchStats(); // Refresh stats
      } else {
        toast.error(data.message || 'Failed to create institution');
      }
    } catch (error) {
      console.error('Error creating institution:', error);
      toast.error('Failed to create institution');
    }
  };

  const fetchCsvHistory = async () => {
    // For now, just keep a local history in state (could be extended to backend later)
    const history = JSON.parse(localStorage.getItem('admin_csv_history') || '[]');
    setCsvHistory(history);
  };

  const fetchOfferLetters = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/offer-letters`);
      const data = await res.json();
      if (data.success) setOfferLetters(data.offerLetters);
    } catch {}
  };

  // Debounced search function
  const debouncedSearch = useCallback(
    (() => {
      let timeoutId;
      return (searchTerm) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          setSearch(searchTerm);
          setCurrentPage(1);
          if (tab === 'candidates') fetchCandidates();
          else if (tab === 'unregistered') fetchUnregisteredCandidates();
          else if (tab === 'companies') fetchCompanies();
          else if (tab === 'institutions') fetchInstitutions();
        }, 500); // 500ms delay
      };
    })(),
    [tab]
  );

  const handleSearch = e => {
    e.preventDefault();
    setCurrentPage(1);
    if (tab === 'candidates') fetchCandidates();
    else if (tab === 'unregistered') fetchUnregisteredCandidates();
    else if (tab === 'companies') fetchCompanies();
    else if (tab === 'institutions') fetchInstitutions();
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    debouncedSearch(value);
  };

  const handleEdit = item => {
    setSelectedItem(item);
    // Handle different entity types with their respective field names
    // Ensure all values are strings to prevent controlled/uncontrolled input issues
    if (tab === 'institutions') {
      setEditForm({
        name: item.name || '',
        email: item.email || '',
        mobile: item.contact_mobile || '', // Institutions use contact_mobile
        password: ''
      });
    } else {
      setEditForm({
        name: item.name || item.company_name || '', // Use company_name for companies
        email: item.email || '',
        mobile: item.mobile || '', // Candidates/companies use mobile
        company_type: item.company_type || '', // Only for companies
        establishment_code: item.establishment_code || '', // Only for companies
        needs_offer_letter: !!item.needs_offer_letter,
        needs_certificate: !!item.needs_certificate,
        password: ''
      });
    }
  };

  const handleSave = async e => {
    e.preventDefault();
    let endpoint;
    if (tab === 'candidates') endpoint = 'candidates';
    else if (tab === 'companies') endpoint = 'companies';
    else if (tab === 'institutions') endpoint = 'institutions';
    
    // Prepare the data to send, mapping mobile field correctly for institutions
    let dataToSend = { ...editForm };
    if (tab === 'institutions') {
      dataToSend.contact_mobile = editForm.mobile;
      delete dataToSend.mobile; // Remove the generic mobile field
    }
    
    console.log('Sending update data:', dataToSend);
    
    const res = await adminFetch(`${API_URL}/api/admin/${endpoint}/${selectedItem.id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dataToSend)
    });
    const data = await res.json();
    console.log('Update response:', data);
    if (data.success) {
      setSelectedItem(null);
      setEditForm({
        name: '',
        email: '',
        mobile: '',
        company_type: '',
        establishment_code: '',
        needs_offer_letter: false,
        needs_certificate: false,
        password: ''
      });
      if (tab === 'candidates') fetchCandidates();
      else if (tab === 'unregistered') fetchUnregisteredCandidates();
      else if (tab === 'companies') fetchCompanies();
      else if (tab === 'institutions') fetchInstitutions();
    }
  };

  // Add function to fetch sales invoices
  const fetchSalesInvoices = async (month, year) => {
    if (!month || !year) return;
    
    setInvoiceLoading(true);
    try {
      // Ensure month is a number (1-12)
      const numericMonth = parseInt(month, 10);
      const response = await adminFetch(`${API_URL}/api/v1/sales-invoice/get-sales-invoice?month=${numericMonth}&year=${year}`);
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          const invoices = data.rows || [];
          setInvoiceList(invoices);
        } else if (data.rows) {
          // Handle eduvantage format: { headers, rows, metaData }
          const invoices = data.rows || [];
          setInvoiceList(invoices);
        } else {
          setInvoiceList([]);
          console.warn('Sales invoice API returned no data for month:', month, 'year:', year);
        }
      } else {
        setInvoiceList([]);
        console.warn('Sales invoice API not available (404) - this is normal for some setups');
      }
    } catch (error) {
      setInvoiceList([]);
      console.warn('Sales invoice API not available - this is normal for some setups');
    } finally {
      setInvoiceLoading(false);
    }
  };

  // Add function to handle invoice selection
  const handleInvoiceSelect = (invoice) => {
    setSelectedInvoice(invoice);
    // Auto-fill company name if available
    if (invoice['Particulars']) {
      const form = document.querySelector('form');
      if (form) {
        const companyInput = form.querySelector('input[name="company_name"]');
        if (companyInput) {
          companyInput.value = invoice['Particulars'];
        }
      }
    }
  };

  // Modify handleCsvUpload to include invoice information
  const handleCsvUpload = async (e) => {
    e.preventDefault();
    setUploading(true);
    setUploadResult(null);
    
    const formData = new FormData();
    const file = e.target.file.files[0];
    const docType = e.target.document_type.value;
    
    // Safely get form field values with null checks
    const monthField = e.target.month;
    const yearField = e.target.year;
    const establishmentCodeField = e.target.establishment_code;
    
    const month = monthField ? monthField.value : null;
    const year = yearField ? yearField.value : null;
    const establishmentCode = establishmentCodeField ? establishmentCodeField.value : null;

    // Validate establishment code for stipend, DBT, BVOC, and NATS documents
    if (
      ((docImportTab === 'naps' && (docType === 'stipend' || docType === 'dbt')) ||
        docImportTab === 'bvoc' ||
        (docImportTab === 'nats' && docType === 'nats_stipend')) &&
      !selectedEstablishmentCode
    ) {
      setUploadResult({ success: false, message: 'Please select an establishment ID for stipend/DBT documents' });
      setUploading(false);
      return;
    }

    formData.append('file', file);
    formData.append('document_type', docType);
    
    // Append establishment_code for stipend, DBT, BVOC, and NATS documents (contract has it in CSV)
    if (
      ((docImportTab === 'naps' && (docType === 'stipend' || docType === 'dbt')) ||
        docImportTab === 'bvoc' ||
        (docImportTab === 'nats' && docType === 'nats_stipend')) &&
      selectedEstablishmentCode
    ) {
      formData.append('establishment_code', selectedEstablishmentCode);
    }
    // Capture company name when establishment is selected (so backend can store on Documents/uploaded_csv_files)
    const companyNameInput = e.target.company_name ? e.target.company_name.value : (selectedEstablishmentCompanyName || '');
    if (
      ((docImportTab === 'naps' && (docType === 'stipend' || docType === 'dbt')) ||
        docImportTab === 'bvoc' ||
        (docImportTab === 'nats' && docType === 'nats_stipend')) &&
      (companyNameInput || selectedEstablishmentCompanyName)
    ) {
      formData.append('company_name', companyNameInput || selectedEstablishmentCompanyName);
    }

    // Only append year, month if they exist and are for NAPS/NATS documents
    if ((docImportTab === 'naps' || docImportTab === 'nats') && year && month) {
      formData.append('year', year);
      formData.append('month', month);
      
      // Add invoice information if available
      if (selectedInvoice) {
        formData.append('voucher_no', selectedInvoice['Voucher No.']);
        formData.append('voucher_type', selectedInvoice['Voucher Type']);
      }
    }
    
    // For BVOC and Salaried documents, add year/month if available
    if ((docImportTab === 'bvoc' || docImportTab === 'salaried') && year && month) {
      formData.append('year', year);
      formData.append('month', month);
      formData.append('company_name', companyNameInput);
    }

    // Debug: Log establishment code value and type
    if (docImportTab === 'bvoc' && selectedEstablishmentCode) {
      console.log('BVOC Establishment Code:', selectedEstablishmentCode, 'Type:', typeof selectedEstablishmentCode);
    }

    try {
      let uploadUrl = `${API_URL}/api/documents/upload`;
      if (docType === 'contract') {
        uploadUrl = `${API_URL}/api/documents/upload/contract`;
      } else if (docType === 'stipend') {
        uploadUrl = `${API_URL}/api/documents/upload/stipend`;
      } else if (docType === 'bvoc_salary') {
        uploadUrl = `${API_URL}/api/documents/upload/bvoc-salary`;
      } else if (docType === 'salary') {
        uploadUrl = `${API_URL}/api/documents/upload/salaried-salary`;
      } else if (docType === 'nats_stipend') {
        uploadUrl = `${API_URL}/api/documents/upload/nats-stipend`;
      }

      const res = await fetch(uploadUrl, {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      
      if (res.ok) {
        setUploadResult({ success: true, imported: data.imported || data.totalRecords });
        // Save to local history
        const newHistory = [
          { 
            fileName: file.name, 
            type: docType, 
            date: new Date().toLocaleString(), 
            imported: data.imported || data.totalRecords,
            invoice: selectedInvoice ? selectedInvoice['Voucher No.'] : null
          },
          ...csvHistory
        ].slice(0, 10);
        setCsvHistory(newHistory);
        localStorage.setItem('admin_csv_history', JSON.stringify(newHistory));
      } else {
        setUploadResult({ success: false, message: data.message });
      }
    } catch (err) {
      setUploadResult({ success: false, message: err.message });
    } finally {
      setUploading(false);
      e.target.reset();
      setSelectedInvoice(null);
    }
  };

  // Sales invoice fetching removed - not needed for current functionality
  // useEffect(() => {
  //   if (docImportTab === 'naps' && stipendReportMonth && stipendReportYear) {
  //     fetchSalesInvoices(stipendReportMonth, stipendReportYear);
  //   }
  // }, [docImportTab, stipendReportMonth, stipendReportYear]);

  // Clear company name input when switching document types
  useEffect(() => {
    if (docImportTab === 'naps' || docImportTab === 'nats') {
      setCompanyNameInput('');
    }
  }, [docImportTab]);

  // Fetch establishment IDs when NAPS, NATS, or BVOC tab is selected
  useEffect(() => {
    if (docImportTab === 'naps') {
      fetchNapsEstablishmentIds();
    } else if (docImportTab === 'bvoc') {
      fetchBvocEstablishmentIds();
    } else if (docImportTab === 'nats') {
      fetchNatsEstablishmentIds();
    }
    setSelectedEstablishmentCode('');
    setSelectedEstablishmentCompanyName('');
  }, [docImportTab]);

  // Function to fetch NAPS establishment IDs
  const fetchNapsEstablishmentIds = async () => {
    try {
      const response = await adminFetch(`${API_URL}/api/v1/establishment/establishment-ids`);
      const data = await response.json();
      
      if (data.success) {
        // Filter for NAPS companies only
        const napsCompanies = data.data.filter(company => 
          company.companyType === 'naps' || company.companyType === 'NAPS'
        );
        setNapsEstablishmentIds(napsCompanies);
      }
    } catch (error) {
      console.error('Error fetching NAPS establishment IDs:', error);
    }
  };

  // Function to fetch BVOC establishment IDs
  const fetchBvocEstablishmentIds = async () => {
    try {
      const response = await adminFetch(`${API_URL}/api/v1/establishment/establishment-ids`);
      const data = await response.json();
      
      if (data.success) {
        // Filter for BVOC companies only
        const bvocCompanies = data.data.filter(company => 
          company.companyType === 'bvoc' || company.companyType === 'BVOC'
        );
        setBvocEstablishmentIds(bvocCompanies);
      }
    } catch (error) {
      console.error('Error fetching BVOC establishment IDs:', error);
    }
  };

  // Function to fetch NATS establishment IDs
  const fetchNatsEstablishmentIds = async () => {
    try {
      const response = await adminFetch(`${API_URL}/api/v1/establishment/establishment-ids`);
      const data = await response.json();
      
      if (data.success) {
        const natsCompanies = data.data.filter(company => 
          company.companyType === 'nats' || company.companyType === 'NATS'
        );
        setNatsEstablishmentIds(natsCompanies);
      }
    } catch (error) {
      console.error('Error fetching NATS establishment IDs:', error);
    }
  };

  // Candidate search
  const handleCandidateSearch = async () => {
    if (!candidateSearch || candidateSearch.length < 2) return;
    const res = await fetch(`${API_URL}/api/admin/candidates/search?query=${encodeURIComponent(candidateSearch)}`);
    const data = await res.json();
    if (data.success) setCandidateResults(data.candidates);
  };

  // Initiate offer letter
  const handleCreateOfferLetter = async () => {
    setOfferStatus('');
    
    // Build body based on selected format
    const body = {
      candidate_id: selectedCandidate?.id || null,
      name: offerForm.name,
      address: offerForm.address,
      company_name: offerForm.company_name,
      offer_letter_format: offerForm.offer_letter_format || 'timex',
      created_by: 1 // TODO: use real admin id
    };

    // Add format-specific fields
    if (offerForm.offer_letter_format === 'timex') {
      body.mobile = offerForm.mobile;
      body.registration_no = offerForm.registration_no;
      body.program_name = offerForm.program_name;
    } else {
      // Standard/Salaried format
      body.so_name = offerForm.so_name;
      body.designation = offerForm.designation;
      body.location = offerForm.location;
      body.compensation = offerForm.compensation || {};
    }

    try {
      const res = await fetch(`${API_URL}/api/admin/offer-letters`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      
      if (data.success) {
        setOfferStatus('✅ Offer letter created successfully!');
        
        // Reset form
        setOfferForm({
          name: '', so_name: '', address: '', company_name: '', 
          designation: '', location: '', compensation: {},
          mobile: '', registration_no: '', program_name: '',
          offer_letter_format: 'timex'
        });
        setSelectedCandidate(null);
        setCandidateSearch('');
        setCandidateResults([]);
        
        // Refresh the list
        fetchOfferLetters();
        
        // Optionally switch to list tab after creation
        setTimeout(() => {
          setOfferLetterTab('list');
        }, 2000);
      } else {
        setOfferStatus(`❌ Error: ${data.error || 'Failed to create offer letter'}`);
      }
    } catch (error) {
      setOfferStatus(`❌ Failed to create offer letter: ${error.message}`);
    }
  };

  // Handle bulk upload
  const handleBulkUpload = async () => {
    setBulkStatus('');
    setBulkLoading(true);

    if (!bulkFile) {
      setBulkStatus('Please select an Excel file');
      setBulkLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append('excel_file', bulkFile);
    formData.append('offer_letter_format', offerForm.offer_letter_format || 'timex');

    try {
      const res = await fetch(`${API_URL}/api/admin/offer-letters/bulk`, {
        method: 'POST',
        body: formData
      });
      
      const data = await res.json();
      
      if (data.success) {
        setBulkStatus(`✅ Successfully generated ${data.count} offer letters!`);
        
        // Trigger download
        const downloadLink = document.createElement('a');
        downloadLink.href = `${API_URL}${data.downloadUrl}`;
        downloadLink.click();
        
        // Reset form
        setBulkFile(null);
        document.getElementById('bulk-file-input').value = '';
      } else {
        setBulkStatus(`❌ Error: ${data.error}`);
      }
    } catch (error) {
      setBulkStatus(`❌ Upload failed: ${error.message}`);
    } finally {
      setBulkLoading(false);
    }
  };

  // Download template
  const handleDownloadTemplate = () => {
    const downloadLink = document.createElement('a');
    downloadLink.href = `${API_URL}/api/admin/offer-letters/template`;
    downloadLink.download = 'timex_bulk_template.csv';
    downloadLink.click();
  };

  const handleDownloadStipendReport = async () => {
    try {
      const url = `${API_URL}/api/admin/naps-stipend-report?year=${stipendReportYear}&month=${stipendReportMonth}`;
      const response = await adminFetch(url);
      if (!response.ok) throw new Error('Failed to download report');
      
      // Get the blob from the response
      const blob = await response.blob();
      
      // Create a download link
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `naps_stipend_report_${stipendReportYear}_${stipendReportMonth}.csv`;
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Error downloading stipend report:', error);
      alert('Failed to download report. Please try again.');
    }
  };

  const handleDownloadNatsStipendReport = async () => {
    try {
      const url = `${API_URL}/api/admin/nats-stipend-report?year=${stipendReportYear}&month=${stipendReportMonth}`;
      const response = await adminFetch(url);
      if (!response.ok) throw new Error('Failed to download report');
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = `nats_stipend_report_${stipendReportYear}_${stipendReportMonth}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Error downloading NATS stipend report:', error);
      alert('Failed to download NATS report. Please try again.');
    }
  };

  // Sidebar navigation config
  const navTabs = [
    { key: 'quiz', label: 'Quiz', icon: <FaChartBar /> },
    { key: 'candidates', label: 'Candidates', icon: <FaUsers /> },
    { key: 'unregistered', label: 'Unregistered', icon: <FaUsers /> },
    { key: 'companies', label: 'Companies', icon: <FaBuilding /> },
    { key: 'supervisors', label: 'Supervisors', icon: <FaUsers /> },
    { key: 'spocs', label: 'SPOCs', icon: <FaUsers /> },
    { key: 'institutions', label: 'Institutions', icon: <FaBuilding /> },
    { key: 'notifications', label: 'Notifications', icon: <FaBell /> },
    { key: 'attendanceReport', label: 'Attendance Report', icon: <FaChartBar /> },
    { key: 'rewards', label: 'Rewards', icon: <FaGift /> },
    { key: 'gamingReport', label: 'Gaming Report', icon: <FaChartBar /> },
    { key: 'referralReport', label: 'Referral Report', icon: <FaFileAlt /> },
    { key: 'referredCandidatesStipendReport', label: 'Referred Candidates Stipend Report', icon: <FaChartBar /> },
    { key: 'spocReport', label: 'SPOC Report', icon: <FaChartBar /> },
    { key: 'spocUploadStatus', label: 'SPOC Upload Status', icon: <FaFileAlt /> },
    { key: 'courses', label: 'Course Management', icon: <FaGraduationCap /> },
    { key: 'documents', label: 'Documents', icon: <FaFileAlt /> },
    { key: 'documentApi', label: 'Document API', icon: <FaLock /> },
    { key: 'workDiary', label: 'Work Diary', icon: <FaFileAlt /> },
    { key: 'salaryAdvance', label: 'Salary Advance', icon: <FaMoneyCheckAlt /> },
    { key: 'higherEducation', label: 'Higher Education', icon: <FaGraduationCap /> },
    { key: 'retentionReport', label: 'Retention Report', icon: <FaHistory /> },
    { key: 'assessmentDueReport', label: 'Assessment Due Report', icon: <FaHistory /> },
    { key: 'companyReports', label: 'Company Reports', icon: <FaChartBar /> },
    { key: 'attritionReport', label: 'Attrition Report', icon: <FaHistory /> },
    { key: 'jobs', label: 'Jobs', icon: <FaUsers /> },
  ];

  // Notification functions
  const fetchNotifications = async () => {
    setNotificationLoading(true);
    try {
      const res = await adminFetch(`${API_URL}/api/admin/notifications`);
      const data = await res.json();
      if (data.success) {
        setNotifications(data.notifications);
      }
    } catch (error) {
      toast.error('Failed to fetch notifications');
    } finally {
      setNotificationLoading(false);
    }
  };

  const handleCreateNotification = async (e) => {
    e.preventDefault();
    if (!notificationForm.title || !notificationForm.message) {
      toast.error('Title and message are required');
      return;
    }

    setNotificationLoading(true);
    try {
      const formData = new FormData();
      formData.append('title', notificationForm.title);
      formData.append('message', notificationForm.message);
      formData.append('type', notificationForm.type);
      formData.append('target_audience', notificationForm.target_audience);
      if (notificationForm.image) {
        formData.append('image', notificationForm.image);
      }

      const res = await adminFetch(`${API_URL}/api/admin/notifications`, {
        method: 'POST',
        body: formData,
        headers: {} // Don't set Content-Type for FormData
      });

      const data = await res.json();
      if (data.success) {
        toast.success('Notification created successfully');
        setShowNotificationForm(false);
        setNotificationForm({ title: '', message: '', type: 'general', target_audience: 'all', image: null });
        fetchNotifications();
      } else {
        toast.error(data.message || 'Failed to create notification');
      }
    } catch (error) {
      toast.error('Failed to create notification');
    } finally {
      setNotificationLoading(false);
    }
  };

  const handleSendNotification = async (notificationId) => {
    try {
      const res = await adminFetch(`${API_URL}/api/admin/notifications/${notificationId}/send`, {
        method: 'POST'
      });
      const data = await res.json();
      if (data.success) {
        toast.success(data.message || 'Notification sent to users');
      } else {
        toast.error(data.message || 'Failed to send notification');
      }
    } catch (error) {
      toast.error('Failed to send notification');
    }
  };

  const handleDeleteNotification = async (notificationId) => {
    if (!window.confirm('Are you sure you want to delete this notification?')) return;
    
    try {
      const res = await adminFetch(`${API_URL}/api/admin/notifications/${notificationId}`, {
        method: 'DELETE'
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Notification deleted successfully');
        fetchNotifications();
      } else {
        toast.error(data.message || 'Failed to delete notification');
      }
    } catch (error) {
      toast.error('Failed to delete notification');
    }
  };

  const handleEditNotification = (notification) => {
    setEditingNotification(notification);
    setNotificationForm({
      title: notification.title,
      message: notification.message,
      type: notification.type,
      target_audience: notification.target_audience,
      image: null
    });
    setShowNotificationForm(true);
  };

  const handleUpdateNotification = async (e) => {
    e.preventDefault();
    if (!notificationForm.title || !notificationForm.message) {
      toast.error('Title and message are required');
      return;
    }

    setNotificationLoading(true);
    try {
      const formData = new FormData();
      formData.append('title', notificationForm.title);
      formData.append('message', notificationForm.message);
      formData.append('type', notificationForm.type);
      formData.append('target_audience', notificationForm.target_audience);
      if (notificationForm.image) {
        formData.append('image', notificationForm.image);
      }

      const res = await adminFetch(`${API_URL}/api/admin/notifications/${editingNotification.id}`, {
        method: 'PUT',
        body: formData,
        headers: {} // Don't set Content-Type for FormData
      });

      const data = await res.json();
      if (data.success) {
        toast.success('Notification updated successfully');
        setShowNotificationForm(false);
        setEditingNotification(null);
        setNotificationForm({ title: '', message: '', type: 'general', target_audience: 'all', image: null });
        fetchNotifications();
      } else {
        toast.error(data.message || 'Failed to update notification');
      }
    } catch (error) {
      toast.error('Failed to update notification');
    } finally {
      setNotificationLoading(false);
    }
  };

  // Fetch all jobs for admin
  const fetchJobs = async () => {
    setLoading(true);
    const res = await adminFetch(`${API_URL}/api/admin/jobs`);
    const data = await res.json();
    if (data.success) setJobs(data.jobs);
    setLoading(false);
  };

  // Supervisor management functions
  const fetchSupervisors = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: String(supervisorPage),
        limit: String(SUPERVISOR_PAGE_SIZE),
        search: supervisorSearch || ''
      });
      const res = await adminFetch(`${API_URL}/api/admin/supervisors?${params}`);
      const data = await res.json();
      if (data.success) {
        setSupervisors(data.supervisors);
        setSupervisorTotal(data.total ?? 0);
        setSupervisorTotalPages(data.totalPages ?? 1);
      }
    } catch (error) {
      console.error('Error fetching supervisors:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateSupervisor = async (e) => {
    e.preventDefault();
    if (!supervisorForm.company_id) {
      toast.error('Please select Establishment Name (Company)');
      return;
    }
    try {
      const res = await adminFetch(`${API_URL}/api/admin/supervisors`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(supervisorForm)
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Supervisor created successfully!');
        setShowSupervisorForm(false);
        setSupervisorForm({ name: '', email: '', mobile: '', password: '', role: 'supervisor', permissions: {}, spoc_id: '', company_id: '' });
        fetchSupervisors();
      } else {
        toast.error(data.message || 'Failed to create supervisor');
      }
    } catch (error) {
      toast.error('Failed to create supervisor');
    }
  };

  const handleUpdateSupervisor = async (e) => {
    e.preventDefault();
    try {
      const res = await adminFetch(`${API_URL}/api/admin/supervisors/${editingSupervisor.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(supervisorForm)
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Supervisor updated successfully!');
        setShowSupervisorForm(false);
        setEditingSupervisor(null);
        setSupervisorForm({ name: '', email: '', mobile: '', password: '', role: 'supervisor', permissions: {}, spoc_id: '', company_id: '' });
        fetchSupervisors();
      } else {
        toast.error(data.message || 'Failed to update supervisor');
      }
    } catch (error) {
      toast.error('Failed to update supervisor');
    }
  };

  const handleDeleteSupervisor = async (id) => {
    if (!window.confirm('Are you sure you want to delete this supervisor?')) return;
    
    try {
      const res = await adminFetch(`${API_URL}/api/admin/supervisors/${id}`, {
        method: 'DELETE'
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Supervisor deleted successfully!');
        fetchSupervisors();
      } else {
        toast.error(data.message || 'Failed to delete supervisor');
      }
    } catch (error) {
      toast.error('Failed to delete supervisor');
    }
  };

  const handleEditSupervisor = (supervisor) => {
    setEditingSupervisor(supervisor);
    setSupervisorForm({
      name: supervisor.name,
      email: supervisor.email,
      mobile: supervisor.mobile,
      referral_code: supervisor.referral_code || '',
      company_id: supervisor.company_id || '',
      password: '',
      role: supervisor.role || 'supervisor',
      permissions: supervisor.permissions || {},
      spoc_id: supervisor.spoc_id || ''
    });
    setShowSupervisorForm(true);
  };

  const handleResetPasswordSupervisor = (supervisor) => {
    setResetPasswordSupervisor(supervisor);
    setResetPasswordNew('');
    setResetPasswordConfirm('');
    setShowResetPasswordNew(false);
    setShowResetPasswordConfirm(false);
  };

  const handleSubmitResetPassword = async (e) => {
    e.preventDefault();
    if (!resetPasswordSupervisor) return;
    if (resetPasswordNew.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    if (resetPasswordNew !== resetPasswordConfirm) {
      toast.error('Passwords do not match');
      return;
    }
    try {
      const res = await adminFetch(`${API_URL}/api/admin/supervisors/${resetPasswordSupervisor.id}/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ newPassword: resetPasswordNew })
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Password reset successfully');
        setResetPasswordSupervisor(null);
        setResetPasswordNew('');
        setResetPasswordConfirm('');
        setShowResetPasswordNew(false);
        setShowResetPasswordConfirm(false);
      } else {
        toast.error(data.message || 'Failed to reset password');
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to reset password');
    }
  };

  // Fetch all SPOCs for supervisor form dropdown (no pagination)
  const fetchSpocsForDropdown = async () => {
    try {
      const res = await adminFetch(`${API_URL}/api/admin/spocs?page=1&limit=10000&search=`);
      const data = await res.json();
      if (data.success) setSpocsForDropdown(data.spocs || []);
    } catch (error) {
      console.error('Error fetching SPOCs for dropdown:', error);
    }
  };

  // SPOC management functions (paginated list for SPOC tab)
  const fetchSPOCs = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: String(spocPage),
        limit: String(SPOC_PAGE_SIZE),
        search: spocSearch || ''
      });
      const res = await adminFetch(`${API_URL}/api/admin/spocs?${params}`);
      const data = await res.json();
      if (data.success) {
        setSpocs(data.spocs);
        setSpocTotal(data.total ?? 0);
        setSpocTotalPages(data.totalPages ?? 1);
      }
    } catch (error) {
      toast.error('Failed to fetch SPOCs');
    } finally {
      setLoading(false);
    }
  };

  const handleSPOCSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const url = editingSPOC 
        ? `${API_URL}/api/admin/spocs/${editingSPOC.id}`
        : `${API_URL}/api/admin/spocs`;
      
      const method = editingSPOC ? 'PUT' : 'POST';
      
      const res = await adminFetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(spocForm)
      });
      
      const data = await res.json();
      if (data.success) {
        toast.success(editingSPOC ? 'SPOC updated successfully!' : 'SPOC created successfully!');
        setShowSPOCForm(false);
        setSpocForm({ name: '', email: '', password: '', company_ids: [] });
        setEditingSPOC(null);
        fetchSPOCs();
      } else {
        toast.error(data.message || 'Failed to save SPOC');
      }
    } catch (error) {
      toast.error('Failed to save SPOC');
    }
  };

  const handleDeleteSPOC = async (id) => {
    if (!window.confirm('Are you sure you want to delete this SPOC?')) return;
    
    try {
      const res = await adminFetch(`${API_URL}/api/admin/spocs/${id}`, {
        method: 'DELETE'
      });
      const data = await res.json();
      if (data.success) {
        toast.success('SPOC deleted successfully!');
        fetchSPOCs();
      } else {
        toast.error(data.message || 'Failed to delete SPOC');
      }
    } catch (error) {
      toast.error('Failed to delete SPOC');
    }
  };

  const handleEditSPOC = async (spoc) => {
    setEditingSPOC(spoc);
    setSpocForm({
      name: spoc.name,
      email: spoc.email,
      password: '',
      company_ids: spoc.company_ids || []
    });
    setSpocCompanySearch('');
    setShowSPOCForm(true);
    // Fetch companies for selection
    try {
      const res = await adminFetch(`${API_URL}/api/admin/companies?page=1&limit=1000&search=`);
      const data = await res.json();
      if (data.success) {
        // Filter out companies already assigned to other SPOCs
        // But keep companies assigned to this SPOC (current editing SPOC)
        const allAssignedCompanyIds = new Set();
        spocs.forEach(s => {
          if (s.id !== spoc.id && s.company_ids) {
            s.company_ids.forEach(id => allAssignedCompanyIds.add(id));
          }
        });
        
        const availableCompanies = data.companies.filter(company => {
          // Include if: not assigned to any other SPOC, OR already assigned to this SPOC
          return !allAssignedCompanyIds.has(company.id) || (spoc.company_ids || []).includes(company.id);
        });
        
        setCompanies(availableCompanies);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  // Fetch applicants for a job
  const fetchJobApplicants = async (job) => {
    setSelectedJob(job);
    setShowApplicantsModal(true);
    setJobApplicants([]);
    const res = await adminFetch(`${API_URL}/api/admin/jobs/${job.id}/applicants`);
    const data = await res.json();
    if (data.success) setJobApplicants(data.applicants);
  };

  const copyJobShareLink = async (job) => {
    try {
      const shareUrl = `${window.location.origin}/jobs/${job.id}/share`;
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Job sharing link copied');
    } catch (err) {
      console.error('Copy job share link failed:', err);
      toast.error('Failed to copy sharing link');
    }
  };

  if (!isAuthenticated) {
    if (onLogout) onLogout();
    return null;
  }

  return (
    <div className="admin-layout">
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#0f172a',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
            borderRadius: '12px',
            padding: '16px 20px',
          },
          success: {
            style: {
              background: '#f0fdfa',
              color: '#0f766e',
            },
          },
          error: {
            style: {
              background: '#fef2f2',
              color: '#991b1b',
            },
          },
        }}
      />
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <img src="/logo512.png" alt="GoGig Logo" className="admin-sidebar-brand-logo" />
          <span className="admin-sidebar-brand-title">GoGig Admin</span>
          <span className="admin-sidebar-brand-badge">Dashboard</span>
        </div>
        <nav className="admin-sidebar-nav">
          {navTabs.map(tabBtn => (
            <button
              key={tabBtn.key}
              type="button"
              className={`admin-sidebar-nav-btn ${tab === tabBtn.key ? 'active' : ''}`}
              onClick={() => {
                if (tabBtn.key === 'quiz') onQuiz();
                else setTab(tabBtn.key);
              }}
            >
              <span className="nav-icon">{tabBtn.icon}</span>
              <span>{tabBtn.label}</span>
            </button>
          ))}
        </nav>
        <button type="button" className="admin-sidebar-logout" onClick={onLogout}>Logout</button>
      </aside>
      {/* Main Content */}
      <div className="admin-main">
        {/* Stats Blocks */}
        <div className="admin-stats-grid">
          <div className="admin-stat-card">
            <div className="admin-stat-card-icon primary">
              <FaUsers color="#fff" size={26} />
            </div>
            <div>
              <div className="admin-stat-card-label">Total Candidates</div>
              <div className="admin-stat-card-value">{stats.candidates}</div>
            </div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-card-icon primary">
              <FaBuilding color="#fff" size={26} />
            </div>
            <div>
              <div className="admin-stat-card-label">Total Companies</div>
              <div className="admin-stat-card-value">{stats.companies}</div>
            </div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-card-icon amber">
              <FaGraduationCap color="#fff" size={26} />
            </div>
            <div>
              <div className="admin-stat-card-label">Total Institutions</div>
              <div className="admin-stat-card-value">{stats.institutions || 0}</div>
            </div>
          </div>
        </div>
        {/* Search and Actions */}
        {(tab === 'candidates' || tab === 'unregistered' || tab === 'companies' || tab === 'institutions') && (
          <div style={{ marginBottom: 24, display: 'flex', gap: 20, alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
            {/* Search Form */}
            <form onSubmit={handleSearch} style={{ flex: '1 1 320px', maxWidth: 480 }}>
              <div className="admin-search-bar">
                <input
                  type="text"
                  placeholder={`Search ${tab}...`}
                  value={search}
                  onChange={handleSearchInputChange}
                  aria-label={`Search ${tab}`}
                />
                <button type="submit" className="search-btn" title="Search">
                  <FaSearch />
                </button>
              </div>
            </form>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
              {tab === 'candidates' && (
                <button
                  type="button"
                  className="gogig-card-btn"
                  style={{
                    borderRadius: 20,
                    height: 44,
                    width: 44,
                    minWidth: 44,
                    boxShadow: '0 2px 8px #22c55e22',
                    background: 'linear-gradient(135deg, #22c55e 0%, #2ad2c9 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 0,
                    fontSize: 12,
                    fontWeight: 700,
                    color: '#fff',
                    border: 'none',
                    transition: 'background 0.18s, transform 0.18s',
                    outline: 'none',
                    cursor: 'pointer',
                  }}
                  title="Download CSV"
                  onClick={async () => {
                    let url = `${API_URL}/api/admin/candidates/download`;
                    const params = [];
                    if (search) params.push(`search=${encodeURIComponent(search)}`);
                    if (params.length) url += `?${params.join('&')}`;
                    const res = await fetch(url, { headers: { 'Authorization': `Bearer ${localStorage.getItem('gogig_admin_access')}` } });
                    const blob = await res.blob();
                    const a = document.createElement('a');
                    a.href = window.URL.createObjectURL(blob);
                    a.download = 'candidates.csv';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                  }}
                >
                  CSV
                </button>
              )}
              {tab === 'institutions' && (
                <button
                  type="button"
                  className="gogig-card-btn"
                  style={{
                    borderRadius: 20,
                    height: 44,
                    minWidth: 120,
                    boxShadow: '0 2px 8px #22c55e22',
                    background: 'linear-gradient(135deg, #22c55e 0%, #2ad2c9 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 8,
                    padding: '0 16px',
                    fontSize: 12,
                    fontWeight: 700,
                    color: '#fff',
                    border: 'none',
                    transition: 'background 0.18s, transform 0.18s',
                    outline: 'none',
                    cursor: 'pointer',
                  }}
                  onClick={() => setShowInstitutionForm(true)}
                  title="Create Institution"
                >
                  <FaEdit />
                  Create
                </button>
              )}
            </div>
          </div>
        )}
        
        {/* List */}
        {(tab === 'candidates' || tab === 'unregistered' || tab === 'companies' || tab === 'institutions') && (
          <div className="admin-table-wrap">
            {loading ? (
              <div style={{ padding: 32, textAlign: 'center' }}>
                <div className="admin-spinner" />
              </div>
            ) : (
              ((tab === 'candidates' ? candidates : tab === 'unregistered' ? unregisteredCandidates : tab === 'companies' ? companies : institutions).length > 0 ? (
                <div style={{ width: '100%', overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, background: '#fff' }}>
                    <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                      <tr style={{ background: '#f8fafc', color: '#0f172a', borderBottom: '2px solid #e2e8f0' }}>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>Name</th>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>Email</th>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>Mobile</th>
                        {tab === 'companies' && <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>Establishment Code</th>}
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>
                          {tab === 'institutions' ? 'Rating' : 'Type'}
                        </th>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>
                          {tab === 'institutions' ? 'Contact Person' : 'Company Name'}
                        </th>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>
                          {tab === 'institutions' ? 'City' : 'Details'}
                        </th>
                        {tab === 'candidates' && <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>Additional Details</th>}
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>Status</th>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: 700, fontSize: '0.875rem' }}>Joined Date</th>
                        <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: 700, fontSize: '0.875rem' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(tab === 'candidates' ? candidates : tab === 'unregistered' ? unregisteredCandidates : tab === 'companies' ? companies : institutions).map((item, idx) => (
                        <tr key={item.id} style={{ background: idx % 2 === 0 ? '#f8fafc' : '#fff', transition: 'background 0.2s', cursor: 'pointer' }} onMouseOver={e => e.currentTarget.style.background='#e0f7fa'} onMouseOut={e => e.currentTarget.style.background=idx%2===0?'#f8fafc':'#fff'} onClick={() => tab === 'institutions' ? handleInstitutionSelect(item) : null}>
                          <td style={{ padding: 16 }}>{item.name || item.company_name}</td>
                          <td style={{ padding: 16 }}>{item.email}</td>
                          <td style={{ padding: 16 }}>{tab === 'institutions' ? item.contact_mobile : item.mobile}</td>
                          {tab === 'companies' && <td style={{ padding: 16 }}>{item.establishment_code || 'N/A'}</td>}
                          <td style={{ padding: 16 }}>
                            {tab === 'institutions' ? (
                              <span style={{ 
                                background: '#22c55e', 
                                color: '#fff', 
                                borderRadius: 8, 
                                padding: '4px 14px', 
                                fontWeight: 600, 
                                fontSize: 14 
                              }}>
                                {item.rating ? `${item.rating}/5` : 'N/A'}
                              </span>
                            ) : (
                              <>
                                {item.company_type === 'naps' && (
                                  <span style={{ background: '#22c55e', color: '#fff', borderRadius: 8, padding: '4px 14px', fontWeight: 600, fontSize: 14 }}>NAPS</span>
                                )}
                                {item.company_type === 'bvoc' && (
                                  <span style={{ background: '#3498db', color: '#fff', borderRadius: 8, padding: '4px 14px', fontWeight: 600, fontSize: 14 }}>BVOC</span>
                                )}
                                {item.company_type === 'nats' && (
                                  <span style={{ background: '#8b5cf6', color: '#fff', borderRadius: 8, padding: '4px 14px', fontWeight: 600, fontSize: 14 }}>NATS</span>
                                )}
                                {item.company_type === 'staffing' && (
                                  <span style={{ background: '#f59e0b', color: '#fff', borderRadius: 8, padding: '4px 14px', fontWeight: 600, fontSize: 14 }}>Staffing</span>
                                )}
                                {item.type === 'NAPS' && (
                                  <span style={{ background: '#22c55e', color: '#fff', borderRadius: 8, padding: '4px 14px', fontWeight: 600, fontSize: 14 }}>NAPS</span>
                                )}
                                {item.type === 'Bvoc' && (
                                  <span style={{ background: '#3498db', color: '#fff', borderRadius: 8, padding: '4px 14px', fontWeight: 600, fontSize: 14 }}>BVOC</span>
                                )}
                                {item.type === 'Salaried' && (
                                  <span style={{ background: '#f39c12', color: '#fff', borderRadius: 8, padding: '4px 14px', fontWeight: 600, fontSize: 14 }}>Salaried</span>
                                )}
                                {item.type === 'NATS' && (
                                  <span style={{ background: '#8b5cf6', color: '#fff', borderRadius: 8, padding: '4px 14px', fontWeight: 600, fontSize: 14 }}>NATS</span>
                                )}
                                {!item.company_type && !item.type && (
                                  <span style={{ color: '#888' }}>-</span>
                                )}
                              </>
                            )}
                          </td>
                          <td style={{ padding: 16 }}>
                            {tab === 'institutions' ? (item.contact_person || '-') : (item.company_name || '-')}
                          </td>
                          <td style={{ padding: 16 }}>
                            {tab === 'institutions' ? (
                              item.city || '-'
                            ) : (
                              item.additional_details ? (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleShowDetails(item);
                                  }}
                                  style={{
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 8,
                                    padding: '8px 16px',
                                    fontSize: 12,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    boxShadow: '0 2px 4px rgba(102, 126, 234, 0.2)'
                                  }}
                                  onMouseOver={(e) => {
                                    e.target.style.transform = 'translateY(-1px)';
                                    e.target.style.boxShadow = '0 4px 8px rgba(102, 126, 234, 0.3)';
                                  }}
                                  onMouseOut={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 2px 4px rgba(102, 126, 234, 0.2)';
                                  }}
                                >
                                  View Details
                                </button>
                              ) : '-'
                            )}
                          </td>
                          {tab === 'candidates' && (
                            <td style={{ padding: 16, maxWidth: 250, wordWrap: 'break-word' }}>
                              {(() => {
                                try {
                                  // Check if additional_details exists
                                  if (!item.additional_details) {
                                    return <span style={{ color: '#888' }}>-</span>;
                                  }

                                  // Try to parse as JSON (for supervisor-imported candidates)
                                  let parsedDetails;
                                  try {
                                    parsedDetails = typeof item.additional_details === 'string' 
                                      ? JSON.parse(item.additional_details) 
                                      : item.additional_details;
                                    
                                    // If it's an object with many fields, it's supervisor-imported
                                    // Check if it has supervisor-specific fields
                                    if (typeof parsedDetails === 'object' && parsedDetails !== null) {
                                      const keys = Object.keys(parsedDetails);
                                      // Supervisor-imported candidates have many fields like establishment_name, month, etc.
                                      if (keys.length > 5 || keys.includes('establishment_name') || keys.includes('punching_code')) {
                                        return <span style={{ color: '#666', fontSize: 13 }}>Supervisor Imported</span>;
                                      }
                                      // If it's a simple object, extract meaningful info
                                      const comment = parsedDetails.comment || parsedDetails.comments || parsedDetails.additional_info;
                                      if (comment) {
                                        return <span style={{ color: '#374151', fontSize: 13 }} title={comment}>{comment.length > 50 ? comment.substring(0, 50) + '...' : comment}</span>;
                                      }
                                    }
                                  } catch (e) {
                                    // If parsing fails, it's likely a plain string (self-registered candidate comments)
                                    const comment = typeof item.additional_details === 'string' 
                                      ? item.additional_details 
                                      : String(item.additional_details);
                                    
                                    // Check if it's a simple comment (not a JSON string)
                                    if (!comment.startsWith('{') && !comment.startsWith('[')) {
                                      return <span style={{ color: '#374151', fontSize: 13 }} title={comment}>{comment.length > 50 ? comment.substring(0, 50) + '...' : comment}</span>;
                                    }
                                  }
                                  
                                  // Default fallback
                                  return <span style={{ color: '#888' }}>-</span>;
                                } catch (error) {
                                  console.error('Error parsing additional_details:', error);
                                  return <span style={{ color: '#888' }}>-</span>;
                                }
                              })()}
                            </td>
                          )}
                          <td style={{ padding: 16 }}>
                            {tab === 'institutions' ? (
                              <span style={{ 
                                color: item.status === 'active' ? '#22c55e' : item.status === 'pending' ? '#f59e0b' : '#ef4444', 
                                fontWeight: 600 
                              }}>
                                {item.status || 'pending'}
                              </span>
                            ) : (
                              item.isEmployed ? <span style={{ color: '#22c55e', fontWeight: 600 }}>Employed</span> : <span style={{ color: '#888' }}>Unemployed</span>
                            )}
                          </td>
                          <td style={{ padding: 16, fontSize: 14, color: '#666' }}>
                            {item.created_at ? new Date(item.created_at).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            }) : '-'}
                          </td>
                          <td style={{ padding: 8, textAlign: 'center' }}>
                            <button 
                              className="gogig-card-btn-outline"
                              style={{ padding: '8px 12px', borderRadius: 8, border: '1.5px solid #22c55e', background: '#e0f7fa', color: '#22c55e', fontWeight: 700, transition: 'background 0.2s, color 0.2s' }}
                              onClick={() => handleEdit(item)}
                            >
                              <FaEdit />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div style={{ padding: 32, textAlign: 'center', color: '#888', fontSize: 18 }}>
                  No records found.
                </div>
              ))
            )}
          </div>
        )}
        {/* Pagination - Modern style */}
        {(tab === 'candidates' || tab === 'unregistered' || tab === 'companies' || tab === 'institutions') && listTotal > 0 && (
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 16,
            marginTop: 20,
            padding: '16px 20px',
            background: '#fff',
            borderRadius: 12,
            border: '1px solid #e2e8f0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
          }}>
            <span style={{ fontSize: 14, color: '#64748b' }}>
              Showing {((currentPage - 1) * ITEMS_PER_PAGE) + 1}–{Math.min(currentPage * ITEMS_PER_PAGE, listTotal)} of {listTotal} {tab === 'candidates' ? 'candidates' : tab === 'unregistered' ? 'candidates' : tab === 'companies' ? 'companies' : 'institutions'}
            </span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <button
                type="button"
                onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                disabled={currentPage <= 1}
                style={{
                  padding: '8px 14px',
                  borderRadius: 8,
                  border: '1px solid #e2e8f0',
                  background: currentPage <= 1 ? '#f8fafc' : '#fff',
                  color: currentPage <= 1 ? '#94a3b8' : '#475569',
                  fontWeight: 500,
                  cursor: currentPage <= 1 ? 'not-allowed' : 'pointer',
                  fontSize: 14
                }}
              >
                ‹ Previous
              </button>
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {Array.from({ length: Math.min(5, listTotalPages) }, (_, i) => {
                  let pageNum;
                  if (listTotalPages <= 5) pageNum = i + 1;
                  else if (currentPage <= 3) pageNum = i + 1;
                  else if (currentPage >= listTotalPages - 2) pageNum = listTotalPages - 4 + i;
                  else pageNum = currentPage - 2 + i;
                  if (pageNum < 1) return null;
                  return (
                    <button
                      key={pageNum}
                      type="button"
                      onClick={() => setCurrentPage(pageNum)}
                      style={{
                        minWidth: 36,
                        height: 36,
                        padding: '0 10px',
                        borderRadius: 8,
                        border: currentPage === pageNum ? 'none' : '1px solid #e2e8f0',
                        background: currentPage === pageNum ? 'linear-gradient(135deg, #22c55e 0%, #2ad2c9 100%)' : '#fff',
                        color: currentPage === pageNum ? '#fff' : '#475569',
                        fontWeight: currentPage === pageNum ? 600 : 500,
                        cursor: 'pointer',
                        fontSize: 14
                      }}
                    >
                      {pageNum}
                    </button>
                  );
                })}
              </div>
              <button
                type="button"
                onClick={() => setCurrentPage(p => Math.min(listTotalPages, p + 1))}
                disabled={currentPage >= listTotalPages}
                style={{
                  padding: '8px 14px',
                  borderRadius: 8,
                  border: '1px solid #e2e8f0',
                  background: currentPage >= listTotalPages ? '#f8fafc' : '#fff',
                  color: currentPage >= listTotalPages ? '#94a3b8' : '#475569',
                  fontWeight: 500,
                  cursor: currentPage >= listTotalPages ? 'not-allowed' : 'pointer',
                  fontSize: 14
                }}
              >
                Next ›
              </button>
            </div>
          </div>
        )}

        {/* Institution Management Interface */}
        {tab === 'institutions' && selectedInstitution && (
          <div style={{ marginTop: 32 }}>
            {/* Institution Header */}
            <div style={{ 
              background: 'linear-gradient(135deg, #22c55e 0%, #2ad2c9 100%)', 
              borderRadius: 16, 
              padding: 24, 
              marginBottom: 24,
              color: '#fff'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h2 style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>{selectedInstitution.name}</h2>
                  <p style={{ margin: '8px 0 0 0', opacity: 0.9 }}>{selectedInstitution.email} • {selectedInstitution.city}, {selectedInstitution.state}</p>
                </div>
                <button
                  onClick={() => {
                    setSelectedInstitution(null);
                    setInstitutionManagementView('overview');
                  }}
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    borderRadius: 8,
                    padding: '8px 16px',
                    color: '#fff',
                    cursor: 'pointer',
                    fontWeight: 600
                  }}
                >
                  Back to List
                </button>
              </div>
            </div>

            {/* Management Tabs */}
            <div style={{ 
              display: 'flex', 
              gap: 8, 
              marginBottom: 24,
              background: '#f8fafc',
              borderRadius: 12,
              padding: 4
            }}>
              {[
                { key: 'overview', label: 'Overview', icon: '📊' },
                { key: 'courses', label: 'Courses', icon: '📚' },
                { key: 'students', label: 'Students', icon: '👥' },
                { key: 'campus_visits', label: 'Campus Visits', icon: '🏢' }
              ].map(tabItem => (
                <button
                  key={tabItem.key}
                  onClick={() => handleManagementViewChange(tabItem.key)}
                  style={{
                    flex: 1,
                    padding: '12px 16px',
                    borderRadius: 8,
                    border: 'none',
                    background: institutionManagementView === tabItem.key ? '#22c55e' : 'transparent',
                    color: institutionManagementView === tabItem.key ? '#fff' : '#666',
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 8
                  }}
                >
                  <span>{tabItem.icon}</span>
                  {tabItem.label}
                </button>
              ))}
            </div>

            {/* Management Content */}
            {institutionManagementView === 'overview' && (
              <div style={{ 
                background: '#fff', 
                borderRadius: 16, 
                padding: 24,
                boxShadow: '0 2px 16px rgba(34,197,94,0.07)',
                border: '1.5px solid #e5e7eb'
              }}>
                <h3 style={{ marginBottom: 16 }}>Institution Overview</h3>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
                  <div style={{ textAlign: 'center', padding: 16, background: '#f8fafc', borderRadius: 8 }}>
                    <div style={{ fontSize: 24, fontWeight: 700, color: '#22c55e' }}>{courses.length}</div>
                    <div style={{ color: '#666' }}>Total Courses</div>
                  </div>
                  <div style={{ textAlign: 'center', padding: 16, background: '#f8fafc', borderRadius: 8 }}>
                    <div style={{ fontSize: 24, fontWeight: 700, color: '#22c55e' }}>{students.length}</div>
                    <div style={{ color: '#666' }}>Total Students</div>
                  </div>
                  <div style={{ textAlign: 'center', padding: 16, background: '#f8fafc', borderRadius: 8 }}>
                    <div style={{ fontSize: 24, fontWeight: 700, color: '#22c55e' }}>{campusVisits.length}</div>
                    <div style={{ color: '#666' }}>Campus Visits</div>
                  </div>
                </div>
              </div>
            )}

            {institutionManagementView === 'courses' && (
              <div>
                {/* Courses Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                  <h3 style={{ margin: 0 }}>Courses Management</h3>
                  <button
                    onClick={() => setShowCourseForm(true)}
                    style={{
                      background: 'linear-gradient(135deg, #22c55e 0%, #2ad2c9 100%)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      padding: '10px 20px',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    + Add Course
                  </button>
                </div>

                {/* Courses Table */}
                <div style={{ 
                  background: '#fff', 
                  borderRadius: 16, 
                  overflow: 'hidden',
                  boxShadow: '0 2px 16px rgba(34,197,94,0.07)',
                  border: '1.5px solid #e5e7eb'
                }}>
                  {courses.length > 0 ? (
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead style={{ background: '#f8fafc' }}>
                        <tr>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Course Name</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Trade Code</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Duration</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Total Seats</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Current Students</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Status</th>
                          <th style={{ padding: 16, textAlign: 'center', fontWeight: 700 }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {courses.map((course, idx) => (
                          <tr key={course.id} style={{ background: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                            <td style={{ padding: 16 }}>{course.course_name}</td>
                            <td style={{ padding: 16 }}>{course.trade_code || '-'}</td>
                            <td style={{ padding: 16 }}>{course.duration_months ? `${course.duration_months} months` : '-'}</td>
                            <td style={{ padding: 16 }}>{course.total_seats}</td>
                            <td style={{ padding: 16 }}>{course.current_students}</td>
                            <td style={{ padding: 16 }}>
                              <span style={{
                                background: course.status === 'active' ? '#22c55e' : '#f59e0b',
                                color: '#fff',
                                padding: '4px 12px',
                                borderRadius: 6,
                                fontSize: 12,
                                fontWeight: 600
                              }}>
                                {course.status}
                              </span>
                            </td>
                            <td style={{ padding: 16, textAlign: 'center' }}>
                              <button
                                style={{
                                  background: '#22c55e',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 6,
                                  padding: '6px 12px',
                                  fontSize: 12,
                                  cursor: 'pointer',
                                  marginRight: 8
                                }}
                              >
                                Edit
                              </button>
                              <button
                                style={{
                                  background: '#ef4444',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 6,
                                  padding: '6px 12px',
                                  fontSize: 12,
                                  cursor: 'pointer'
                                }}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>
                      No courses found. Click "Add Course" to create the first course.
                    </div>
                  )}
                </div>
              </div>
            )}

            {institutionManagementView === 'students' && (
              <div>
                {/* Students Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                  <h3 style={{ margin: 0 }}>Students Management</h3>
                  <button
                    onClick={() => setShowStudentForm(true)}
                    style={{
                      background: 'linear-gradient(135deg, #22c55e 0%, #2ad2c9 100%)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      padding: '10px 20px',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    + Add Student
                  </button>
                </div>

                {/* Students Table */}
                <div style={{ 
                  background: '#fff', 
                  borderRadius: 16, 
                  overflow: 'hidden',
                  boxShadow: '0 2px 16px rgba(34,197,94,0.07)',
                  border: '1.5px solid #e5e7eb'
                }}>
                  {students.length > 0 ? (
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead style={{ background: '#f8fafc' }}>
                        <tr>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Student Name</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Roll Number</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Course</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Email</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Mobile</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Gender</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Status</th>
                          <th style={{ padding: 16, textAlign: 'center', fontWeight: 700 }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {students.map((student, idx) => (
                          <tr key={student.id} style={{ background: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                            <td style={{ padding: 16 }}>{student.student_name}</td>
                            <td style={{ padding: 16 }}>{student.roll_number}</td>
                            <td style={{ padding: 16 }}>{student.InstitutionCourse?.course_name || '-'}</td>
                            <td style={{ padding: 16 }}>{student.email || '-'}</td>
                            <td style={{ padding: 16 }}>{student.mobile}</td>
                            <td style={{ padding: 16 }}>{student.gender}</td>
                            <td style={{ padding: 16 }}>
                              <span style={{
                                background: student.status === 'active' ? '#22c55e' : '#f59e0b',
                                color: '#fff',
                                padding: '4px 12px',
                                borderRadius: 6,
                                fontSize: 12,
                                fontWeight: 600
                              }}>
                                {student.status}
                              </span>
                            </td>
                            <td style={{ padding: 16, textAlign: 'center' }}>
                              <button
                                style={{
                                  background: '#22c55e',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 6,
                                  padding: '6px 12px',
                                  fontSize: 12,
                                  cursor: 'pointer',
                                  marginRight: 8
                                }}
                              >
                                Edit
                              </button>
                              <button
                                style={{
                                  background: '#ef4444',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 6,
                                  padding: '6px 12px',
                                  fontSize: 12,
                                  cursor: 'pointer'
                                }}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>
                      No students found. Click "Add Student" to create the first student.
                    </div>
                  )}
                </div>
              </div>
            )}

            {institutionManagementView === 'campus_visits' && (
              <div>
                {/* Campus Visits Header */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                  <h3 style={{ margin: 0 }}>Campus Visits Management</h3>
                  <button
                    onClick={() => setShowCampusVisitForm(true)}
                    style={{
                      background: 'linear-gradient(135deg, #22c55e 0%, #2ad2c9 100%)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      padding: '10px 20px',
                      fontWeight: 600,
                      cursor: 'pointer'
                    }}
                  >
                    + Schedule Visit
                  </button>
                </div>

                {/* Campus Visits Table */}
                <div style={{ 
                  background: '#fff', 
                  borderRadius: 16, 
                  overflow: 'hidden',
                  boxShadow: '0 2px 16px rgba(34,197,94,0.07)',
                  border: '1.5px solid #e5e7eb'
                }}>
                  {campusVisits.length > 0 ? (
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead style={{ background: '#f8fafc' }}>
                        <tr>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Visit Date</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Company</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Contact Person</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Purpose</th>
                          <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Status</th>
                          <th style={{ padding: 16, textAlign: 'center', fontWeight: 700 }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {campusVisits.map((visit, idx) => (
                          <tr key={visit.id} style={{ background: idx % 2 === 0 ? '#fff' : '#f8fafc' }}>
                            <td style={{ padding: 16 }}>{new Date(visit.visit_date).toLocaleDateString()}</td>
                            <td style={{ padding: 16 }}>{visit.company_name}</td>
                            <td style={{ padding: 16 }}>{visit.contact_person}</td>
                            <td style={{ padding: 16 }}>{visit.visit_purpose}</td>
                            <td style={{ padding: 16 }}>
                              <span style={{
                                background: visit.visit_status === 'completed' ? '#22c55e' : visit.visit_status === 'scheduled' ? '#3b82f6' : '#f59e0b',
                                color: '#fff',
                                padding: '4px 12px',
                                borderRadius: 6,
                                fontSize: 12,
                                fontWeight: 600
                              }}>
                                {visit.visit_status}
                              </span>
                            </td>
                            <td style={{ padding: 16, textAlign: 'center' }}>
                              <button
                                style={{
                                  background: '#22c55e',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 6,
                                  padding: '6px 12px',
                                  fontSize: 12,
                                  cursor: 'pointer',
                                  marginRight: 8
                                }}
                              >
                                Edit
                              </button>
                              <button
                                style={{
                                  background: '#ef4444',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 6,
                                  padding: '6px 12px',
                                  fontSize: 12,
                                  cursor: 'pointer'
                                }}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>
                      No campus visits found. Click "Schedule Visit" to create the first campus visit.
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Edit Modal */}
        {selectedItem && editForm && editForm.name !== undefined && (
          <div className="gogig-modal-bg" onClick={() => setSelectedItem(null)}>
            <div className="gogig-modal" onClick={e => e.stopPropagation()}>
              <h3 style={{ marginBottom: 24 }}>Edit {tab === 'candidates' ? 'Candidate' : tab === 'companies' ? 'Company' : 'Institution'}</h3>
              <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <input
                  type="text"
                  placeholder="Name"
                  value={editForm.name || ''}
                  onChange={e => setEditForm({ ...editForm, name: e.target.value })}
                  className="gogig-input"
                  required
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={editForm.email || ''}
                  onChange={e => setEditForm({ ...editForm, email: e.target.value })}
                  className="gogig-input"
                  required
                />
                <input
                  type="tel"
                  placeholder="Mobile"
                  value={editForm.mobile || ''}
                  onChange={e => setEditForm({ ...editForm, mobile: e.target.value })}
                  className="gogig-input"
                  required
                />
                {tab === 'companies' && (
                  <>
                    <select
                      value={editForm.company_type || ''}
                      onChange={e => setEditForm({ ...editForm, company_type: e.target.value })}
                      className="gogig-input"
                      required
                    >
                      <option value="">Select Company Type</option>
                      <option value="naps">NAPS</option>
                      <option value="bvoc">BVOC</option>
                      <option value="nats">NATS</option>
                      <option value="staffing">Staffing</option>
                    </select>
                    <input
                      type="text"
                      placeholder="Establishment Code"
                      value={editForm.establishment_code || ''}
                      onChange={e => setEditForm({ ...editForm, establishment_code: e.target.value })}
                      className="gogig-input"
                    />
                    <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: 14 }}>
                      <div style={{ fontWeight: 700, marginBottom: 8, color: '#0f172a' }}>Document API capabilities</div>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={!!editForm.needs_offer_letter}
                          onChange={e => setEditForm({ ...editForm, needs_offer_letter: e.target.checked })}
                        />
                        Offer letter (email Accept / Decline + partner callback)
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                        <input
                          type="checkbox"
                          checked={!!editForm.needs_certificate}
                          onChange={e => setEditForm({ ...editForm, needs_certificate: e.target.checked })}
                        />
                        Certificate (generate PDF via API only)
                      </label>
                      <p style={{ margin: '10px 0 0', fontSize: 12, color: '#64748b' }}>
                        After enabling, generate an API key from the Document API sidebar tab.
                      </p>
                    </div>
                  </>
                )}
                <input
                  type="password"
                  placeholder="New Password (leave blank to keep current)"
                  value={editForm.password || ''}
                  onChange={e => setEditForm({ ...editForm, password: e.target.value })}
                  className="gogig-input"
                />
                <div style={{ display: 'flex', gap: 12 }}>
                  <button type="submit" className="gogig-card-btn">Save</button>
                  <button type="button" className="gogig-card-btn-outline" onClick={() => setSelectedItem(null)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Create Institution Modal */}
        {showInstitutionForm && (
          <div className="gogig-modal-bg" onClick={() => setShowInstitutionForm(false)}>
            <div className="gogig-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600, maxHeight: '90vh', overflowY: 'auto' }}>
              <h3 style={{ marginBottom: 24 }}>Create New Institution</h3>
              <form onSubmit={handleCreateInstitution} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="text"
                    placeholder="Institution Name *"
                    value={institutionForm.name}
                    onChange={e => setInstitutionForm({ ...institutionForm, name: e.target.value })}
                    className="gogig-input"
                    required
                  />
                  <input
                    type="email"
                    placeholder="Email *"
                    value={institutionForm.email}
                    onChange={e => setInstitutionForm({ ...institutionForm, email: e.target.value })}
                    className="gogig-input"
                    required
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="password"
                    placeholder="Password *"
                    value={institutionForm.password}
                    onChange={e => setInstitutionForm({ ...institutionForm, password: e.target.value })}
                    className="gogig-input"
                    required
                  />
                  <input
                    type="tel"
                    placeholder="Contact Mobile *"
                    value={institutionForm.contact_mobile}
                    onChange={e => setInstitutionForm({ ...institutionForm, contact_mobile: e.target.value })}
                    className="gogig-input"
                    required
                  />
                </div>
                <input
                  type="text"
                  placeholder="Contact Person *"
                  value={institutionForm.contact_person}
                  onChange={e => setInstitutionForm({ ...institutionForm, contact_person: e.target.value })}
                  className="gogig-input"
                  required
                />
                <textarea
                  placeholder="Address *"
                  value={institutionForm.address}
                  onChange={e => setInstitutionForm({ ...institutionForm, address: e.target.value })}
                  className="gogig-input"
                  rows={3}
                  required
                />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
                  <input
                    type="text"
                    placeholder="City *"
                    value={institutionForm.city}
                    onChange={e => setInstitutionForm({ ...institutionForm, city: e.target.value })}
                    className="gogig-input"
                    required
                  />
                  <input
                    type="text"
                    placeholder="State *"
                    value={institutionForm.state}
                    onChange={e => setInstitutionForm({ ...institutionForm, state: e.target.value })}
                    className="gogig-input"
                    required
                  />
                  <input
                    type="text"
                    placeholder="Pincode *"
                    value={institutionForm.pincode}
                    onChange={e => setInstitutionForm({ ...institutionForm, pincode: e.target.value })}
                    className="gogig-input"
                    required
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="url"
                    placeholder="Website (optional)"
                    value={institutionForm.website}
                    onChange={e => setInstitutionForm({ ...institutionForm, website: e.target.value })}
                    className="gogig-input"
                  />
                  <input
                    type="number"
                    placeholder="Rating (0-5)"
                    value={institutionForm.rating}
                    onChange={e => setInstitutionForm({ ...institutionForm, rating: parseFloat(e.target.value) || 0 })}
                    className="gogig-input"
                    min="0"
                    max="5"
                    step="0.1"
                  />
                </div>
                <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                  <button type="submit" className="gogig-card-btn">Create Institution</button>
                  <button type="button" className="gogig-card-btn-outline" onClick={() => setShowInstitutionForm(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Create Course Modal */}
        {showCourseForm && (
          <div className="gogig-modal-bg" onClick={() => setShowCourseForm(false)}>
            <div className="gogig-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600, maxHeight: '90vh', overflowY: 'auto' }}>
              <h3 style={{ marginBottom: 24 }}>Create New Course</h3>
              <form onSubmit={handleCreateCourse} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="text"
                    placeholder="Course Name *"
                    value={courseForm.course_name}
                    onChange={e => setCourseForm({ ...courseForm, course_name: e.target.value })}
                    className="gogig-input"
                    required
                  />
                  <input
                    type="text"
                    placeholder="Trade Code"
                    value={courseForm.trade_code}
                    onChange={e => setCourseForm({ ...courseForm, trade_code: e.target.value })}
                    className="gogig-input"
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="number"
                    placeholder="Duration (months)"
                    value={courseForm.duration_months}
                    onChange={e => setCourseForm({ ...courseForm, duration_months: parseInt(e.target.value) || '' })}
                    className="gogig-input"
                  />
                  <input
                    type="number"
                    placeholder="Total Seats *"
                    value={courseForm.total_seats}
                    onChange={e => setCourseForm({ ...courseForm, total_seats: parseInt(e.target.value) || '' })}
                    className="gogig-input"
                    required
                  />
                </div>
                <textarea
                  placeholder="Course Description"
                  value={courseForm.course_description}
                  onChange={e => setCourseForm({ ...courseForm, course_description: e.target.value })}
                  className="gogig-input"
                  rows={3}
                />
                <textarea
                  placeholder="Eligibility Criteria"
                  value={courseForm.eligibility_criteria}
                  onChange={e => setCourseForm({ ...courseForm, eligibility_criteria: e.target.value })}
                  className="gogig-input"
                  rows={3}
                />
                <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                  <button type="submit" className="gogig-card-btn">Create Course</button>
                  <button type="button" className="gogig-card-btn-outline" onClick={() => setShowCourseForm(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Create Student Modal */}
        {showStudentForm && (
          <div className="gogig-modal-bg" onClick={() => setShowStudentForm(false)}>
            <div className="gogig-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600, maxHeight: '90vh', overflowY: 'auto' }}>
              <h3 style={{ marginBottom: 24 }}>Add New Student</h3>
              <form onSubmit={handleCreateStudent} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <select
                  value={studentForm.course_id}
                  onChange={e => setStudentForm({ ...studentForm, course_id: e.target.value })}
                  className="gogig-input"
                  required
                >
                  <option value="">Select Course *</option>
                  {courses.map(course => (
                    <option key={course.id} value={course.id}>{course.course_name}</option>
                  ))}
                </select>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="text"
                    placeholder="Student Name *"
                    value={studentForm.student_name}
                    onChange={e => setStudentForm({ ...studentForm, student_name: e.target.value })}
                    className="gogig-input"
                    required
                  />
                  <input
                    type="text"
                    placeholder="Roll Number *"
                    value={studentForm.roll_number}
                    onChange={e => setStudentForm({ ...studentForm, roll_number: e.target.value })}
                    className="gogig-input"
                    required
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="email"
                    placeholder="Email"
                    value={studentForm.email}
                    onChange={e => setStudentForm({ ...studentForm, email: e.target.value })}
                    className="gogig-input"
                  />
                  <input
                    type="tel"
                    placeholder="Mobile *"
                    value={studentForm.mobile}
                    onChange={e => setStudentForm({ ...studentForm, mobile: e.target.value })}
                    className="gogig-input"
                    required
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <select
                    value={studentForm.gender}
                    onChange={e => setStudentForm({ ...studentForm, gender: e.target.value })}
                    className="gogig-input"
                    required
                  >
                    <option value="">Select Gender *</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                  <input
                    type="date"
                    placeholder="Date of Birth"
                    value={studentForm.date_of_birth}
                    onChange={e => setStudentForm({ ...studentForm, date_of_birth: e.target.value })}
                    className="gogig-input"
                  />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="text"
                    placeholder="Father Name"
                    value={studentForm.father_name}
                    onChange={e => setStudentForm({ ...studentForm, father_name: e.target.value })}
                    className="gogig-input"
                  />
                  <input
                    type="text"
                    placeholder="Mother Name"
                    value={studentForm.mother_name}
                    onChange={e => setStudentForm({ ...studentForm, mother_name: e.target.value })}
                    className="gogig-input"
                  />
                </div>
                <textarea
                  placeholder="Address"
                  value={studentForm.address}
                  onChange={e => setStudentForm({ ...studentForm, address: e.target.value })}
                  className="gogig-input"
                  rows={2}
                />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="date"
                    placeholder="Admission Date *"
                    value={studentForm.admission_date}
                    onChange={e => setStudentForm({ ...studentForm, admission_date: e.target.value })}
                    className="gogig-input"
                    required
                  />
                  <input
                    type="date"
                    placeholder="Expected Completion Date"
                    value={studentForm.expected_completion_date}
                    onChange={e => setStudentForm({ ...studentForm, expected_completion_date: e.target.value })}
                    className="gogig-input"
                  />
                </div>
                <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                  <button type="submit" className="gogig-card-btn">Add Student</button>
                  <button type="button" className="gogig-card-btn-outline" onClick={() => setShowStudentForm(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Create Campus Visit Modal */}
        {showCampusVisitForm && (
          <div className="gogig-modal-bg" onClick={() => setShowCampusVisitForm(false)}>
            <div className="gogig-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600, maxHeight: '90vh', overflowY: 'auto' }}>
              <h3 style={{ marginBottom: 24 }}>Schedule Campus Visit</h3>
              <form onSubmit={handleCreateCampusVisit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="date"
                    placeholder="Visit Date *"
                    value={campusVisitForm.visit_date}
                    onChange={e => setCampusVisitForm({ ...campusVisitForm, visit_date: e.target.value })}
                    className="gogig-input"
                    required
                  />
                  <select
                    value={campusVisitForm.visit_status}
                    onChange={e => setCampusVisitForm({ ...campusVisitForm, visit_status: e.target.value })}
                    className="gogig-input"
                  >
                    <option value="scheduled">Scheduled</option>
                    <option value="in_progress">In Progress</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                </div>
                <input
                  type="text"
                  placeholder="Company Name *"
                  value={campusVisitForm.company_name}
                  onChange={e => setCampusVisitForm({ ...campusVisitForm, company_name: e.target.value })}
                  className="gogig-input"
                  required
                />
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                  <input
                    type="text"
                    placeholder="Contact Person *"
                    value={campusVisitForm.contact_person}
                    onChange={e => setCampusVisitForm({ ...campusVisitForm, contact_person: e.target.value })}
                    className="gogig-input"
                    required
                  />
                  <input
                    type="tel"
                    placeholder="Contact Mobile"
                    value={campusVisitForm.contact_mobile}
                    onChange={e => setCampusVisitForm({ ...campusVisitForm, contact_mobile: e.target.value })}
                    className="gogig-input"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Visit Purpose *"
                  value={campusVisitForm.visit_purpose}
                  onChange={e => setCampusVisitForm({ ...campusVisitForm, visit_purpose: e.target.value })}
                  className="gogig-input"
                  required
                />
                <textarea
                  placeholder="Notes"
                  value={campusVisitForm.notes}
                  onChange={e => setCampusVisitForm({ ...campusVisitForm, notes: e.target.value })}
                  className="gogig-input"
                  rows={3}
                />
                <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                  <button type="submit" className="gogig-card-btn">Schedule Visit</button>
                  <button type="button" className="gogig-card-btn-outline" onClick={() => setShowCampusVisitForm(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        {tab === 'attendanceReport' && (() => {
          const adminToken = localStorage.getItem('gogig_admin_token');
          console.log('Admin token being used:', adminToken);
          return <AdminAttendanceReport token={adminToken} />;
        })()}
        {tab === 'rewards' && (
          <AdminRewardsDashboard />
        )}
        {tab === 'gamingReport' && (
          <div className="admin-report-section" style={{ minHeight: 400 }}>
            <AdminGamingReport getToken={async () => (await getAdminAccessToken()) || localStorage.getItem('gogig_admin_access')} />
          </div>
        )}
        {tab === 'referralReport' && <AdminReferralReport />}
        {tab === 'referredCandidatesStipendReport' && <AdminReferredCandidatesStipendReport />}
        {tab === 'spocReport' && <AdminSPOCReport />}
        {tab === 'spocUploadStatus' && <AdminSPOCUploadStatusReport />}
        {tab === 'courses' && <AdminCourseManagement />}
        {tab === 'documentApi' && <AdminDocumentApi />}
        {tab === 'documents' && (
          <div style={{
            minHeight: '100%',
            padding: '32px 24px 48px',
            maxWidth: 960,
            margin: '0 auto',
          }}>
            {/* Page header */}
            <div style={{
              marginBottom: 32,
              textAlign: 'center',
            }}>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 56,
                height: 56,
                borderRadius: 16,
                background: 'linear-gradient(135deg, #0d9488 0%, #10b981 50%, #059669 100%)',
                boxShadow: '0 8px 24px rgba(13, 148, 136, 0.35)',
                marginBottom: 16,
              }}>
                <FaFileAlt style={{ fontSize: 28, color: '#fff' }} />
              </div>
              <h1 style={{
                fontSize: 28,
                fontWeight: 800,
                color: '#0f172a',
                margin: 0,
                letterSpacing: '-0.02em',
              }}>
                Document Hub
              </h1>
              <p style={{ marginTop: 8, fontSize: 15, color: '#64748b', fontWeight: 500 }}>
                Upload contracts, stipends & salary slips by category
              </p>
            </div>

            {/* Category tabs - pill style */}
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 12,
              justifyContent: 'center',
              marginBottom: 32,
            }}>
              {[
                { id: 'naps', label: 'NAPS Documents', short: 'NAPS' },
                { id: 'bvoc', label: 'B.Voc Documents', short: 'B.Voc' },
                { id: 'salaried', label: 'Salaried', short: 'Salaried' },
                { id: 'nats', label: 'NATS Documents', short: 'NATS' },
              ].map(({ id, label, short }) => {
                const active = docImportTab === id;
                return (
                  <button
                    key={id}
                    type="button"
                    onClick={() => setDocImportTab(id)}
                    style={{
                      padding: '12px 24px',
                      borderRadius: 14,
                      fontWeight: 700,
                      fontSize: 14,
                      border: active ? 'none' : '2px solid #e2e8f0',
                      background: active ? 'linear-gradient(135deg, #0d9488 0%, #059669 100%)' : '#fff',
                      color: active ? '#fff' : '#475569',
                      boxShadow: active ? '0 4px 14px rgba(13, 148, 136, 0.4)' : '0 1px 3px rgba(0,0,0,0.06)',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      outline: 'none',
                    }}
                    onMouseOver={(e) => {
                      if (!active) { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.borderColor = '#cbd5e1'; }
                    }}
                    onMouseOut={(e) => {
                      if (!active) { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; }
                    }}
                  >
                    {short}
                  </button>
                );
              })}
            </div>

            {/* Upload card */}
            <div style={{
              background: '#fff',
              borderRadius: 20,
              boxShadow: '0 4px 24px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)',
              padding: 40,
              marginBottom: 32,
            }}>
              <div style={{ marginBottom: 28, paddingBottom: 20, borderBottom: '2px solid #f1f5f9' }}>
                <h2 style={{ fontSize: 18, fontWeight: 700, color: '#0f172a', margin: 0 }}>
                  Upload document
                </h2>
                <p style={{ marginTop: 6, fontSize: 14, color: '#64748b' }}>
                  Choose type, period, then select a CSV file to import
                </p>
              </div>

              <form onSubmit={handleCsvUpload} style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 20 }}>
                  <div>
                    <label style={{ display: 'block', fontWeight: 600, color: '#334155', marginBottom: 8, fontSize: 13 }}>Document type</label>
                    <select
                      name="document_type"
                      required
                      value={selectedDocumentType}
                      onChange={(e) => setSelectedDocumentType(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '12px 14px',
                        borderRadius: 12,
                        border: '2px solid #e2e8f0',
                        background: '#f8fafc',
                        fontSize: 14,
                        fontWeight: 500,
                        color: '#0f172a',
                      }}
                    >
                      <option value="">Select type</option>
                      {docImportTab === 'naps' && <><option value="contract">Contract</option><option value="stipend">Stipend</option><option value="dbt">DBT</option></>}
                      {docImportTab === 'bvoc' && <option value="bvoc_salary">Stipend</option>}
                      {docImportTab === 'salaried' && <option value="salary">Salary Slip</option>}
                      {docImportTab === 'nats' && <option value="nats_stipend">NATS Stipend</option>}
                    </select>
                  </div>
                  <div>
                    <label style={{ display: 'block', fontWeight: 600, color: '#334155', marginBottom: 8, fontSize: 13 }}>Year</label>
                    <input
                      type="number"
                      name="year"
                      required
                      min="2000"
                      max="2100"
                      value={stipendReportYear}
                      onChange={e => setStipendReportYear(Number(e.target.value))}
                      style={{
                        width: '100%',
                        padding: '12px 14px',
                        borderRadius: 12,
                        border: '2px solid #e2e8f0',
                        background: '#f8fafc',
                        fontSize: 14,
                        fontWeight: 500,
                        color: '#0f172a',
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontWeight: 600, color: '#334155', marginBottom: 8, fontSize: 13 }}>Month</label>
                    <select
                      name="month"
                      required
                      value={stipendReportMonth}
                      onChange={e => setStipendReportMonth(Number(e.target.value))}
                      style={{
                        width: '100%',
                        padding: '12px 14px',
                        borderRadius: 12,
                        border: '2px solid #e2e8f0',
                        background: '#f8fafc',
                        fontSize: 14,
                        fontWeight: 500,
                        color: '#0f172a',
                      }}
                    >
                      {[1,2,3,4,5,6,7,8,9,10,11,12].map(m => (
                        <option key={m} value={m}>{new Date(2000, m - 1).toLocaleString('default', { month: 'long' })}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {((docImportTab === 'naps' && selectedDocumentType !== 'contract') || docImportTab === 'bvoc' || docImportTab === 'nats') && (
                  <div>
                    <label style={{ display: 'block', fontWeight: 600, color: '#334155', marginBottom: 8, fontSize: 13 }}>Establishment ID *</label>
                    <EstablishmentDropdown
                      establishments={
                        docImportTab === 'naps'
                          ? napsEstablishmentIds
                          : docImportTab === 'nats'
                            ? natsEstablishmentIds
                            : bvocEstablishmentIds
                      }
                      onSelect={(value, establishment) => {
                        setSelectedEstablishmentCode(value);
                        setSelectedEstablishmentCompanyName(establishment && establishment.companyName ? establishment.companyName : '');
                      }}
                    />
                    <input type="hidden" name="company_name" value={selectedEstablishmentCompanyName || ''} />
                    <select name="establishment_code" value={selectedEstablishmentCode} onChange={(e) => setSelectedEstablishmentCode(e.target.value)} style={{ display: 'none' }} />
                  </div>
                )}

                {/* Template download row */}
                {docImportTab === 'salaried' && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}>
                    <button
                      type="button"
                      onClick={() => {
                        const link = document.createElement('a');
                        link.href = `${API_URL}/api/documents/templates/salaried-salary`;
                        link.download = 'salaried_salary_slip_template.csv';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        toast.success('Template downloaded');
                      }}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 8,
                        padding: '10px 18px',
                        borderRadius: 12,
                        border: 'none',
                        background: 'linear-gradient(135deg, #0d9488 0%, #059669 100%)',
                        color: '#fff',
                        fontWeight: 600,
                        fontSize: 13,
                        cursor: 'pointer',
                        boxShadow: '0 2px 8px rgba(13, 148, 136, 0.3)',
                      }}
                    >
                      <FaDownload /> Download template
                    </button>
                    <span style={{ fontSize: 13, color: '#64748b' }}>Use this CSV format for salary slip upload</span>
                  </div>
                )}
                {docImportTab === 'nats' && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12 }}>
                    <button
                      type="button"
                      onClick={() => {
                        const link = document.createElement('a');
                        link.href = `${API_URL}/api/documents/templates/nats-stipend`;
                        link.download = 'nats_stipend_template.csv';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        toast.success('Template downloaded');
                      }}
                      style={{
                        display: 'inline-flex', alignItems: 'center', gap: 8,
                        padding: '10px 18px', borderRadius: 12, border: 'none',
                        background: 'linear-gradient(135deg, #0d9488 0%, #059669 100%)',
                        color: '#fff', fontWeight: 600, fontSize: 13, cursor: 'pointer',
                        boxShadow: '0 2px 8px rgba(13, 148, 136, 0.3)',
                      }}
                    >
                      <FaDownload /> NATS stipend template
                    </button>
                    <span style={{ fontSize: 13, color: '#64748b' }}>Same CSV format as NAPS stipend</span>
                  </div>
                )}
                {docImportTab === 'naps' && selectedDocumentType && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
                    {selectedDocumentType === 'stipend' && (
                      <button
                        type="button"
                        onClick={() => {
                          const link = document.createElement('a');
                          link.href = `${API_URL}/api/documents/templates/naps-stipend`;
                          link.download = 'naps_stipend_template.csv';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          toast.success('Template downloaded');
                        }}
                        style={{
                          display: 'inline-flex', alignItems: 'center', gap: 8,
                          padding: '10px 18px', borderRadius: 12, border: 'none',
                          background: 'linear-gradient(135deg, #0d9488 0%, #059669 100%)',
                          color: '#fff', fontWeight: 600, fontSize: 13, cursor: 'pointer',
                          boxShadow: '0 2px 8px rgba(13, 148, 136, 0.3)',
                        }}
                      >
                        <FaDownload /> Stipend template
                      </button>
                    )}
                    {selectedDocumentType === 'contract' && (
                      <button
                        type="button"
                        onClick={() => {
                          const link = document.createElement('a');
                          link.href = `${API_URL}/api/documents/templates/naps-contract`;
                          link.download = 'naps_contract_template.csv';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          toast.success('Template downloaded');
                        }}
                        style={{
                          display: 'inline-flex', alignItems: 'center', gap: 8,
                          padding: '10px 18px', borderRadius: 12, border: 'none',
                          background: 'linear-gradient(135deg, #0d9488 0%, #059669 100%)',
                          color: '#fff', fontWeight: 600, fontSize: 13, cursor: 'pointer',
                          boxShadow: '0 2px 8px rgba(13, 148, 136, 0.3)',
                        }}
                      >
                        <FaDownload /> Contract template
                      </button>
                    )}
                  </div>
                )}

                <div>
                  <label style={{ display: 'block', fontWeight: 600, color: '#334155', marginBottom: 8, fontSize: 13 }}>CSV file</label>
                  <input
                    type="file"
                    name="file"
                    accept=".csv"
                    required
                    style={{
                      width: '100%',
                      padding: 14,
                      borderRadius: 12,
                      border: '2px dashed #cbd5e1',
                      background: '#f8fafc',
                      fontSize: 14,
                      color: '#475569',
                    }}
                  />
                </div>

                <button
                  type="submit"
                  disabled={uploading}
                  style={{
                    padding: '14px 24px',
                    borderRadius: 14,
                    border: 'none',
                    background: uploading ? '#94a3b8' : 'linear-gradient(135deg, #0d9488 0%, #059669 100%)',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: 16,
                    cursor: uploading ? 'not-allowed' : 'pointer',
                    boxShadow: uploading ? 'none' : '0 4px 14px rgba(13, 148, 136, 0.4)',
                    transition: 'all 0.2s ease',
                  }}
                >
                  {uploading ? 'Uploading…' : 'Upload'}
                </button>

                {uploadResult && (
                  <div style={{
                    padding: 16,
                    borderRadius: 12,
                    background: uploadResult.success ? '#ecfdf5' : '#fef2f2',
                    color: uploadResult.success ? '#065f46' : '#991b1b',
                    fontWeight: 600,
                    fontSize: 14,
                    border: `1px solid ${uploadResult.success ? '#a7f3d0' : '#fecaca'}`,
                  }}>
                    {uploadResult.success ? `✓ Imported ${uploadResult.imported} records` : `Error: ${uploadResult.message}`}
                  </div>
                )}
              </form>
            </div>

            {/* Upload history */}
            <div style={{
              background: '#fff',
              borderRadius: 20,
              boxShadow: '0 4px 24px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)',
              padding: 28,
              marginBottom: 32,
            }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 16, display: 'flex', alignItems: 'center', gap: 8 }}>
                <FaHistory style={{ color: '#0d9488' }} /> Upload history
              </h3>
              {csvHistory.length === 0 ? (
                <p style={{ margin: 0, color: '#94a3b8', fontSize: 14 }}>No uploads yet</p>
              ) : (
                <div style={{ overflowX: 'auto', borderRadius: 12, border: '1px solid #e2e8f0' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                    <thead>
                      <tr style={{ background: '#f8fafc' }}>
                        <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#475569' }}>File</th>
                        <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#475569' }}>Type</th>
                        <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, color: '#475569' }}>Date</th>
                        <th style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 600, color: '#475569' }}>Records</th>
                      </tr>
                    </thead>
                    <tbody>
                      {csvHistory.map((item, i) => (
                        <tr key={i} style={{ borderTop: '1px solid #e2e8f0', background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                          <td style={{ padding: '12px 16px', fontWeight: 500, color: '#0f172a' }}>{item.fileName}</td>
                          <td style={{ padding: '12px 16px', color: '#64748b' }}>{item.type}</td>
                          <td style={{ padding: '12px 16px', color: '#64748b' }}>{item.date}</td>
                          <td style={{ padding: '12px 16px', textAlign: 'right', fontWeight: 600, color: '#0d9488' }}>{item.imported}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* NAPS / NATS report sections - styled inline */}
            {docImportTab === 'naps' && (
              <div style={{
                background: '#fff',
                borderRadius: 20,
                boxShadow: '0 4px 24px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)',
                padding: 28,
                marginBottom: 32,
              }}>
                <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 16 }}>Download NAPS Stipend Report</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-end' }}>
                  <div>
                    <label style={{ display: 'block', fontWeight: 600, color: '#334155', marginBottom: 6, fontSize: 13 }}>Year</label>
                    <select value={stipendReportYear} onChange={(e) => setStipendReportYear(parseInt(e.target.value))} style={{ padding: '10px 14px', borderRadius: 12, border: '2px solid #e2e8f0', background: '#f8fafc', fontSize: 14 }}>
                      {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ display: 'block', fontWeight: 600, color: '#334155', marginBottom: 6, fontSize: 13 }}>Month</label>
                    <select value={stipendReportMonth} onChange={(e) => setStipendReportMonth(parseInt(e.target.value))} style={{ padding: '10px 14px', borderRadius: 12, border: '2px solid #e2e8f0', background: '#f8fafc', fontSize: 14 }}>
                      {[1,2,3,4,5,6,7,8,9,10,11,12].map(m => <option key={m} value={m}>{new Date(2000, m - 1).toLocaleString('default', { month: 'long' })}</option>)}
                    </select>
                  </div>
                  <button onClick={handleDownloadStipendReport} style={{ padding: '10px 20px', borderRadius: 12, border: 'none', background: 'linear-gradient(135deg, #0d9488 0%, #059669 100%)', color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>
                    Download Report
                  </button>
                </div>
              </div>
            )}
            {docImportTab === 'nats' && (
              <div style={{
                background: '#fff',
                borderRadius: 20,
                boxShadow: '0 4px 24px rgba(0,0,0,0.06), 0 0 0 1px rgba(0,0,0,0.04)',
                padding: 28,
                marginBottom: 32,
              }}>
                <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 16 }}>Download NATS Stipend Report</h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-end' }}>
                  <div>
                    <label style={{ display: 'block', fontWeight: 600, color: '#334155', marginBottom: 6, fontSize: 13 }}>Year</label>
                    <select value={stipendReportYear} onChange={e => setStipendReportYear(parseInt(e.target.value))} style={{ padding: '10px 14px', borderRadius: 12, border: '2px solid #e2e8f0', background: '#f8fafc', fontSize: 14 }}>
                      {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(y => <option key={y} value={y}>{y}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{ display: 'block', fontWeight: 600, color: '#334155', marginBottom: 6, fontSize: 13 }}>Month</label>
                    <select value={stipendReportMonth} onChange={e => setStipendReportMonth(parseInt(e.target.value))} style={{ padding: '10px 14px', borderRadius: 12, border: '2px solid #e2e8f0', background: '#f8fafc', fontSize: 14 }}>
                      {[1,2,3,4,5,6,7,8,9,10,11,12].map(m => <option key={m} value={m}>{new Date(2000, m - 1).toLocaleString('default', { month: 'long' })}</option>)}
                    </select>
                  </div>
                  <button onClick={handleDownloadNatsStipendReport} style={{ padding: '10px 20px', borderRadius: 12, border: 'none', background: 'linear-gradient(135deg, #0d9488 0%, #059669 100%)', color: '#fff', fontWeight: 600, fontSize: 14, cursor: 'pointer' }}>
                    Download Report
                  </button>
                </div>
              </div>
            )}
            {/* Download ZIP button and offer letter section */}
            {docImportTab === 'salaried' && <DownloadZipButton type="salaried" />}
            {docImportTab === 'bvoc' && <DownloadZipButton type="bvoc" />}
            
            {/* Offer Letter Section for Salaried Tab */}
            {docImportTab === 'salaried' && (
              <div style={{ marginTop: 32, padding: 24, background: '#f8fafc', borderRadius: 16, border: '2px solid #e0f7fa' }}>
                <h3 style={{ marginBottom: 20, color: '#22c55e', fontWeight: 700, fontSize: 20 }}>📋 Offer Letter Management</h3>
                
                {/* Tab Navigation */}
                <div style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
                  <button 
                    onClick={() => setOfferLetterTab('create')}
                    style={{ 
                      padding: '12px 24px', 
                      borderRadius: 8, 
                      border: 'none', 
                      background: offerLetterTab === 'create' ? '#22c55e' : '#f0f0f0', 
                      color: offerLetterTab === 'create' ? 'white' : '#666',
                      fontWeight: 600,
                      cursor: 'pointer',
                      fontSize: 14
                    }}
                  >
                    ✨ Create New
                  </button>
                  <button 
                    onClick={() => setOfferLetterTab('bulk')}
                    style={{ 
                      padding: '12px 24px', 
                      borderRadius: 8, 
                      border: 'none', 
                      background: offerLetterTab === 'bulk' ? '#22c55e' : '#f0f0f0', 
                      color: offerLetterTab === 'bulk' ? 'white' : '#666',
                      fontWeight: 600,
                      cursor: 'pointer',
                      fontSize: 14
                    }}
                  >
                    📊 Bulk Upload
                  </button>
                  <button 
                    onClick={() => setOfferLetterTab('list')}
                    style={{ 
                      padding: '12px 24px', 
                      borderRadius: 8, 
                      border: 'none', 
                      background: offerLetterTab === 'list' ? '#22c55e' : '#f0f0f0', 
                      color: offerLetterTab === 'list' ? 'white' : '#666',
                      fontWeight: 600,
                      cursor: 'pointer',
                      fontSize: 14
                    }}
                  >
                    📋 View All
                  </button>
                </div>

                {/* Bulk Upload Tab */}
                {offerLetterTab === 'bulk' && (
                  <div style={{ 
                    background: 'white',
                    borderRadius: 12,
                    padding: 24,
                    border: '1px solid #e0f7fa'
                  }}>
                    <h4 style={{ marginBottom: 20, color: '#22c55e', fontWeight: 700, textAlign: 'center' }}>
                      📊 Bulk Upload Offer Letters
                    </h4>
                    
                    <div style={{ marginBottom: 24 }}>
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: 12,
                        marginBottom: 16,
                        padding: 16,
                        background: '#e0f2fe',
                        borderRadius: 8,
                        border: '1px solid #0891b2'
                      }}>
                        <span style={{ fontSize: 20 }}>💡</span>
                        <div>
                          <div style={{ fontWeight: 600, color: '#0891b2', marginBottom: 4 }}>
                            How it works:
                          </div>
                          <div style={{ fontSize: 14, color: '#0e7490' }}>
                            1. Download template → 2. Fill candidate data → 3. Upload Excel → 4. Get ZIP with PDFs!
                          </div>
                        </div>
                      </div>
                      
                      <button
                        onClick={handleDownloadTemplate}
                        style={{
                          background: '#06b6d4',
                          color: 'white',
                          border: 'none',
                          padding: '12px 20px',
                          borderRadius: 8,
                          fontWeight: 600,
                          cursor: 'pointer',
                          marginBottom: 20,
                          width: '100%',
                          fontSize: 14
                        }}
                      >
                        📥 Download Excel Template
                      </button>
                    </div>

                    {/* Format Selection */}
                    <div style={{ marginBottom: 20 }}>
                      <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                        Offer Letter Format *
                      </label>
                      <select
                        value={offerForm.offer_letter_format || 'timex'}
                        onChange={(e) => setOfferForm({...offerForm, offer_letter_format: e.target.value})}
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          borderRadius: 8,
                          border: '2px solid #e0f7fa',
                          fontSize: 14,
                          background: 'white'
                        }}
                      >
                        <option value="standard">📋 Standard Format</option>
                        <option value="salaried">📝 Salaried Format</option>
                        <option value="timex">🎓 TIMEX Academic Format</option>
                      </select>
                    </div>

                    {/* File Upload */}
                    <div style={{ marginBottom: 20 }}>
                      <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                        Upload Excel File *
                      </label>
                      <input
                        id="bulk-file-input"
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        onChange={(e) => setBulkFile(e.target.files[0])}
                        style={{
                          width: '100%',
                          padding: '12px 16px',
                          borderRadius: 8,
                          border: '2px solid #e0f7fa',
                          fontSize: 14,
                          background: 'white'
                        }}
                      />
                      {bulkFile && (
                        <div style={{ 
                          marginTop: 8, 
                          padding: 8, 
                          background: '#dcfce7', 
                          borderRadius: 6,
                          fontSize: 12,
                          color: '#166534'
                        }}>
                          📎 {bulkFile.name} ({(bulkFile.size / 1024).toFixed(1)} KB)
                        </div>
                      )}
                    </div>

                    {/* Upload Button */}
                    <button
                      onClick={handleBulkUpload}
                      disabled={!bulkFile || bulkLoading}
                      style={{
                        background: bulkFile && !bulkLoading ? '#22c55e' : '#ccc',
                        color: 'white',
                        border: 'none',
                        padding: '16px 24px',
                        borderRadius: 12,
                        fontWeight: 700,
                        cursor: bulkFile && !bulkLoading ? 'pointer' : 'not-allowed',
                        width: '100%',
                        fontSize: 16,
                        opacity: bulkFile && !bulkLoading ? 1 : 0.6
                      }}
                    >
                      {bulkLoading ? '⏳ Processing...' : '🚀 Generate & Download ZIP'}
                    </button>

                    {/* Status */}
                    {bulkStatus && (
                      <div style={{ 
                        marginTop: 16, 
                        padding: 16, 
                        borderRadius: 12,
                        background: bulkStatus.includes('✅') ? '#dcfce7' : '#fee2e2',
                        color: bulkStatus.includes('✅') ? '#166534' : '#991b1b',
                        fontWeight: 600,
                        textAlign: 'center'
                      }}>
                        {bulkStatus}
                      </div>
                    )}
                  </div>
                )}

                {/* Create New Tab */}
                {offerLetterTab === 'create' && (
                  <div style={{ 
                    background: 'white',
                    borderRadius: 12,
                    padding: 24,
                    border: '1px solid #e0f7fa'
                  }}>
                    <h4 style={{ color: '#22c55e', marginBottom: 20, fontWeight: 700 }}>✨ Single Offer Letter Creation</h4>
                    
                    {/* Candidate Search */}
                    <div style={{ marginBottom: 24 }}>
                      <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                        Search Candidate
                      </label>
                      <div style={{ display: 'flex', gap: 12 }}>
                        <input
                          type="text"
                          value={candidateSearch}
                          onChange={(e) => setCandidateSearch(e.target.value)}
                          placeholder="Search by name, email, or mobile..."
                          style={{
                            flex: 1,
                            padding: '12px 16px',
                            borderRadius: 8,
                            border: '2px solid #e0f7fa',
                            fontSize: 14
                          }}
                        />
                        <button
                          onClick={handleCandidateSearch}
                          disabled={candidateSearch.length < 2}
                          style={{
                            background: candidateSearch.length >= 2 ? '#22c55e' : '#ccc',
                            color: 'white',
                            border: 'none',
                            padding: '12px 24px',
                            borderRadius: 8,
                            fontWeight: 600,
                            cursor: candidateSearch.length >= 2 ? 'pointer' : 'not-allowed'
                          }}
                        >
                          Search
                        </button>
                      </div>
                      
                      {/* Search Results */}
                      {candidateResults.length > 0 && (
                        <div style={{ 
                          marginTop: 12, 
                          maxHeight: 200, 
                          overflowY: 'auto',
                          border: '1px solid #e0f7fa',
                          borderRadius: 8,
                          background: '#f8fafc'
                        }}>
                          {candidateResults.map(candidate => (
                            <div
                              key={candidate.id}
                              onClick={() => {
                                setSelectedCandidate(candidate);
                                setOfferForm({
                                  ...offerForm,
                                  name: candidate.name,
                                  address: candidate.address || '',
                                  company_name: candidate.company_name || ''
                                });
                                setCandidateResults([]);
                              }}
                              style={{
                                padding: 12,
                                borderBottom: '1px solid #e0f7fa',
                                cursor: 'pointer',
                                transition: 'background 0.2s'
                              }}
                              onMouseOver={(e) => e.currentTarget.style.background = '#e0f7fa'}
                              onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
                            >
                              <div style={{ fontWeight: 600 }}>{candidate.name}</div>
                              <div style={{ fontSize: 12, color: '#666' }}>
                                {candidate.email} • {candidate.mobile}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Selected Candidate Info */}
                    {selectedCandidate && (
                      <div style={{
                        background: '#e0f7fa',
                        padding: 16,
                        borderRadius: 8,
                        marginBottom: 20,
                        border: '1px solid #22c55e'
                      }}>
                        <div style={{ fontWeight: 600, color: '#22c55e', marginBottom: 4 }}>
                          Selected Candidate:
                        </div>
                        <div>{selectedCandidate.name} - {selectedCandidate.email}</div>
                        <button
                          onClick={() => {
                            setSelectedCandidate(null);
                            setOfferForm({
                              name: '', so_name: '', address: '', company_name: '', 
                              designation: '', location: '', compensation: {},
                              offer_letter_format: 'timex'
                            });
                          }}
                          style={{
                            background: 'none',
                            border: 'none',
                            color: '#ef4444',
                            cursor: 'pointer',
                            fontSize: 12,
                            marginTop: 8,
                            textDecoration: 'underline'
                          }}
                        >
                          Clear Selection
                        </button>
                      </div>
                    )}

                    {/* Offer Letter Form */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
                      <div>
                        <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                          Name *
                        </label>
                        <input
                          type="text"
                          value={offerForm.name}
                          onChange={(e) => setOfferForm({...offerForm, name: e.target.value})}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            borderRadius: 8,
                            border: '2px solid #e0f7fa',
                            fontSize: 14
                          }}
                          required
                        />
                      </div>
                      
                      <div>
                        <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                          Offer Letter Format *
                        </label>
                        <select
                          value={offerForm.offer_letter_format || 'timex'}
                          onChange={(e) => setOfferForm({...offerForm, offer_letter_format: e.target.value})}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            borderRadius: 8,
                            border: '2px solid #e0f7fa',
                            fontSize: 14
                          }}
                        >
                          <option value="standard">📋 Standard Format</option>
                          <option value="salaried">📝 Salaried Format</option>
                          <option value="timex">🎓 TIMEX Academic Format</option>
                        </select>
                      </div>
                    </div>

                    {/* Dynamic Fields based on Format */}
                    {(offerForm.offer_letter_format === 'standard' || offerForm.offer_letter_format === 'salaried') && (
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
                        <div>
                          <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                            S/O Name
                          </label>
                          <input
                            type="text"
                            value={offerForm.so_name || ''}
                            onChange={(e) => setOfferForm({...offerForm, so_name: e.target.value})}
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              borderRadius: 8,
                              border: '2px solid #e0f7fa',
                              fontSize: 14
                            }}
                          />
                        </div>
                        <div>
                          <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                            Designation
                          </label>
                          <input
                            type="text"
                            value={offerForm.designation || ''}
                            onChange={(e) => setOfferForm({...offerForm, designation: e.target.value})}
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              borderRadius: 8,
                              border: '2px solid #e0f7fa',
                              fontSize: 14
                            }}
                          />
                        </div>
                      </div>
                    )}

                    {offerForm.offer_letter_format === 'timex' && (
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
                        <div>
                          <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                            Mobile *
                          </label>
                          <input
                            type="text"
                            value={offerForm.mobile || ''}
                            onChange={(e) => setOfferForm({...offerForm, mobile: e.target.value})}
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              borderRadius: 8,
                              border: '2px solid #e0f7fa',
                              fontSize: 14
                            }}
                            required
                          />
                        </div>
                        <div>
                          <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                            Registration No
                          </label>
                          <input
                            type="text"
                            value={offerForm.registration_no || ''}
                            onChange={(e) => setOfferForm({...offerForm, registration_no: e.target.value})}
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              borderRadius: 8,
                              border: '2px solid #e0f7fa',
                              fontSize: 14
                            }}
                          />
                        </div>
                        <div>
                          <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                            Program Name *
                          </label>
                          <input
                            type="text"
                            value={offerForm.program_name || ''}
                            onChange={(e) => setOfferForm({...offerForm, program_name: e.target.value})}
                            style={{
                              width: '100%',
                              padding: '12px 16px',
                              borderRadius: 8,
                              border: '2px solid #e0f7fa',
                              fontSize: 14
                            }}
                            required
                          />
                        </div>
                      </div>
                    )}

                    {/* Common Fields */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
                      <div>
                        <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                          Address *
                        </label>
                        <textarea
                          value={offerForm.address}
                          onChange={(e) => setOfferForm({...offerForm, address: e.target.value})}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            borderRadius: 8,
                            border: '2px solid #e0f7fa',
                            fontSize: 14,
                            minHeight: 80,
                            resize: 'vertical'
                          }}
                          required
                        />
                      </div>
                      <div>
                        <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                          Company Name *
                        </label>
                        <input
                          type="text"
                          value={offerForm.company_name}
                          onChange={(e) => setOfferForm({...offerForm, company_name: e.target.value})}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            borderRadius: 8,
                            border: '2px solid #e0f7fa',
                            fontSize: 14
                          }}
                          required
                        />
                      </div>
                    </div>

                    {(offerForm.offer_letter_format === 'standard' || offerForm.offer_letter_format === 'salaried') && (
                      <div style={{ marginBottom: 20 }}>
                        <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>
                          Location
                        </label>
                        <input
                          type="text"
                          value={offerForm.location || ''}
                          onChange={(e) => setOfferForm({...offerForm, location: e.target.value})}
                          style={{
                            width: '100%',
                            padding: '12px 16px',
                            borderRadius: 8,
                            border: '2px solid #e0f7fa',
                            fontSize: 14
                          }}
                        />
                      </div>
                    )}

                    {/* Create Button */}
                    <button
                      onClick={handleCreateOfferLetter}
                      disabled={!offerForm.name || !offerForm.address || !offerForm.company_name || 
                                (offerForm.offer_letter_format === 'timex' && (!offerForm.mobile || !offerForm.program_name))}
                      style={{
                        background: offerForm.name && offerForm.address && offerForm.company_name && 
                                  (offerForm.offer_letter_format !== 'timex' || (offerForm.mobile && offerForm.program_name)) 
                                  ? '#22c55e' : '#ccc',
                        color: 'white',
                        border: 'none',
                        padding: '16px 32px',
                        borderRadius: 12,
                        fontWeight: 700,
                        fontSize: 16,
                        cursor: offerForm.name && offerForm.address && offerForm.company_name ? 'pointer' : 'not-allowed',
                        width: '100%'
                      }}
                    >
                      🚀 Create Offer Letter
                    </button>

                    {/* Status */}
                    {offerStatus && (
                      <div style={{
                        marginTop: 16,
                        padding: 16,
                        borderRadius: 12,
                        background: offerStatus.includes('created') ? '#dcfce7' : '#fee2e2',
                        color: offerStatus.includes('created') ? '#166534' : '#991b1b',
                        fontWeight: 600,
                        textAlign: 'center'
                      }}>
                        {offerStatus}
                      </div>
                    )}
                  </div>
                )}

                {/* View All Tab */}
                {offerLetterTab === 'list' && (
                  <div style={{ 
                    background: 'white',
                    borderRadius: 12,
                    padding: 24,
                    border: '1px solid #e0f7fa'
                  }}>
                    <h4 style={{ color: '#22c55e', marginBottom: 20, fontWeight: 700 }}>📋 All Offer Letters</h4>
                    
                    {offerLetters.length === 0 ? (
                      <div style={{ 
                        textAlign: 'center',
                        padding: 32,
                        color: '#666'
                      }}>
                        <div style={{ fontSize: 48, marginBottom: 16 }}>📄</div>
                        <h5 style={{ marginBottom: 8, color: '#333' }}>No offer letters found</h5>
                        <p>Create your first offer letter using the "Create New" tab above.</p>
                      </div>
                    ) : (
                      <div style={{ 
                        background: 'white',
                        borderRadius: 8,
                        overflow: 'hidden',
                        border: '1px solid #e0f7fa'
                      }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                          <thead>
                            <tr style={{ background: '#f8fafc' }}>
                              <th style={{ padding: 12, textAlign: 'left', fontWeight: 600, color: '#22c55e' }}>
                                Candidate Name
                              </th>
                              <th style={{ padding: 12, textAlign: 'left', fontWeight: 600, color: '#22c55e' }}>
                                Company
                              </th>
                              <th style={{ padding: 12, textAlign: 'left', fontWeight: 600, color: '#22c55e' }}>
                                Format
                              </th>
                              <th style={{ padding: 12, textAlign: 'left', fontWeight: 600, color: '#22c55e' }}>
                                Created Date
                              </th>
                              <th style={{ padding: 12, textAlign: 'center', fontWeight: 600, color: '#22c55e' }}>
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {offerLetters.map((letter, index) => (
                              <tr key={letter.id} style={{ 
                                background: index % 2 === 0 ? '#fff' : '#f8fafc',
                                borderBottom: '1px solid #e0f7fa'
                              }}>
                                <td style={{ padding: 12 }}>
                                  <div style={{ fontWeight: 600 }}>{letter.name}</div>
                                  <div style={{ fontSize: 12, color: '#666' }}>
                                    ID: {letter.id}
                                  </div>
                                </td>
                                <td style={{ padding: 12 }}>{letter.company_name}</td>
                                <td style={{ padding: 12 }}>
                                  <span style={{
                                    padding: '4px 8px',
                                    borderRadius: 12,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    background: letter.format === 'timex' ? '#dbeafe' : 
                                               letter.format === 'salaried' ? '#fef3c7' : '#e5e7eb',
                                    color: letter.format === 'timex' ? '#1d4ed8' : 
                                           letter.format === 'salaried' ? '#d97706' : '#6b7280'
                                  }}>
                                    {letter.format ? letter.format.toUpperCase() : 'STANDARD'}
                                  </span>
                                </td>
                                <td style={{ padding: 12, fontSize: 14, color: '#666' }}>
                                  {letter.created_at ? new Date(letter.created_at).toLocaleDateString() : '-'}
                                </td>
                                <td style={{ padding: 12, textAlign: 'center' }}>
                                  <button
                                    onClick={() => {
                                      // Download the offer letter PDF
                                      const link = document.createElement('a');
                                      link.href = `${API_URL}/api/admin/offer-letters/${letter.id}/download`;
                                      link.download = `offer_letter_${letter.name}_${letter.id}.pdf`;
                                      link.click();
                                    }}
                                    style={{
                                      background: '#22c55e',
                                      color: 'white',
                                      border: 'none',
                                      padding: '6px 12px',
                                      borderRadius: 6,
                                      fontSize: 12,
                                      fontWeight: 600,
                                      cursor: 'pointer'
                                    }}
                                  >
                                    📥 Download
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {tab === 'workDiary' && (
          <div style={{ width: '100%', marginTop: 24 }}>
            <AdminWorkDiaryDashboard apiUrl={API_URL} adminFetch={adminFetch} />
          </div>
        )}
        {tab === 'salaryAdvance' && (
          <div style={{ width: '100%' }}>
            <AdminSalaryAdvanceDashboard />
          </div>
        )}
        {tab === 'higherEducation' && (
          <div style={{ width: '100%' }}>
            <AdminHigherEducationDashboard />
          </div>
        )}
        {tab === 'retentionReport' && (
          <div style={{ width: '100%' }}>
            <AdminRetentionReport />
          </div>
        )}
        {tab === 'assessmentDueReport' && (
          <div style={{ width: '100%' }}>
            <AdminAssessmentDueReport />
          </div>
        )}
        {tab === 'companyReports' && (
          <div style={{ width: '100%' }}>
            <AdminCompanyReports />
          </div>
        )}
        {tab === 'attritionReport' && (
          <div style={{ width: '100%' }}>
            <AdminAttritionReport />
          </div>
        )}
        {tab === 'notifications' && (
          <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
              <h2 style={{ fontSize: 28, fontWeight: 800, color: '#22c55e', letterSpacing: 0.5 }}>Notifications Management</h2>
              <button
                className="gogig-card-btn"
                onClick={() => setShowNotificationForm(true)}
                style={{
                  borderRadius: 16,
                  padding: '12px 24px',
                  fontWeight: 700,
                  fontSize: 16,
                  background: 'linear-gradient(90deg, #22c55e 0%, #2ad2c9 100%)',
                  color: '#fff',
                  boxShadow: '0 2px 16px #22c55e44',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                <FaBell style={{ marginRight: 8 }} />
                Create Notification
              </button>
            </div>

            {/* Notification Form Modal */}
            {showNotificationForm && (
              <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
              }}>
                <div style={{
                  background: '#fff',
                  borderRadius: 20,
                  padding: 32,
                  width: '90%',
                  maxWidth: 600,
                  maxHeight: '90vh',
                  overflow: 'auto',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                    <h3 style={{ fontSize: 24, fontWeight: 800, color: '#22c55e' }}>
                      {editingNotification ? 'Edit Notification' : 'Create New Notification'}
                    </h3>
                    <button
                      onClick={() => {
                        setShowNotificationForm(false);
                        setEditingNotification(null);
                        setNotificationForm({ title: '', message: '', type: 'general', target_audience: 'all', image: null });
                      }}
                      style={{
                        background: 'none',
                        border: 'none',
                        fontSize: 24,
                        cursor: 'pointer',
                        color: '#666',
                      }}
                    >
                      ×
                    </button>
                  </div>

                  <form onSubmit={editingNotification ? handleUpdateNotification : handleCreateNotification}>
                    <div style={{ marginBottom: 20 }}>
                      <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>Title *</label>
                      <input
                        type="text"
                        value={notificationForm.title}
                        onChange={(e) => setNotificationForm({...notificationForm, title: e.target.value})}
                        className="gogig-input"
                        style={{ width: '100%', borderRadius: 12, padding: '12px 16px', border: '2px solid #e0f7fa' }}
                        placeholder="Enter notification title"
                        required
                      />
                    </div>

                    <div style={{ marginBottom: 20 }}>
                      <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>Message *</label>
                      <textarea
                        value={notificationForm.message}
                        onChange={(e) => setNotificationForm({...notificationForm, message: e.target.value})}
                        className="gogig-input"
                        style={{ width: '100%', borderRadius: 12, padding: '12px 16px', border: '2px solid #e0f7fa', minHeight: 100, resize: 'vertical' }}
                        placeholder="Enter notification message"
                        required
                      />
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 20 }}>
                      <div>
                        <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>Type</label>
                        <select
                          value={notificationForm.type}
                          onChange={(e) => setNotificationForm({...notificationForm, type: e.target.value})}
                          className="gogig-input"
                          style={{ width: '100%', borderRadius: 12, padding: '12px 16px', border: '2px solid #e0f7fa' }}
                        >
                          <option value="general">General</option>
                          <option value="job_update">Job Update</option>
                          <option value="reward">Reward</option>
                          <option value="announcement">Announcement</option>
                        </select>
                      </div>

                      <div>
                        <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>Target Audience</label>
                        <select
                          value={notificationForm.target_audience}
                          onChange={(e) => setNotificationForm({...notificationForm, target_audience: e.target.value})}
                          className="gogig-input"
                          style={{ width: '100%', borderRadius: 12, padding: '12px 16px', border: '2px solid #e0f7fa' }}
                        >
                          <option value="all">All Users</option>
                          <option value="employed">Employed Only</option>
                          <option value="unemployed">Unemployed Only</option>
                        </select>
                      </div>
                    </div>

                    <div style={{ marginBottom: 24 }}>
                      <label style={{ fontWeight: 600, color: '#22c55e', marginBottom: 8, display: 'block' }}>Image (Optional)</label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => setNotificationForm({...notificationForm, image: e.target.files[0]})}
                        className="gogig-input"
                        style={{ width: '100%', borderRadius: 12, padding: '12px 16px', border: '2px solid #e0f7fa' }}
                      />
                    </div>

                    <div style={{ display: 'flex', gap: 12 }}>
                      <button
                        type="submit"
                        className="gogig-card-btn"
                        disabled={notificationLoading}
                        style={{
                          flex: 1,
                          borderRadius: 12,
                          padding: '14px 24px',
                          fontWeight: 700,
                          fontSize: 16,
                          background: 'linear-gradient(90deg, #22c55e 0%, #2ad2c9 100%)',
                          color: '#fff',
                          border: 'none',
                          cursor: notificationLoading ? 'not-allowed' : 'pointer',
                        }}
                      >
                        {notificationLoading ? 'Saving...' : (editingNotification ? 'Update Notification' : 'Create Notification')}
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setShowNotificationForm(false);
                          setEditingNotification(null);
                          setNotificationForm({ title: '', message: '', type: 'general', target_audience: 'all', image: null });
                        }}
                        style={{
                          flex: 1,
                          borderRadius: 12,
                          padding: '14px 24px',
                          fontWeight: 700,
                          fontSize: 16,
                          background: '#f8fafc',
                          color: '#666',
                          border: '2px solid #e0f7fa',
                          cursor: 'pointer',
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* Notifications List */}
            <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(34,197,94,0.07)', border: '1.5px solid #e5e7eb', overflow: 'hidden' }}>
              {notificationLoading ? (
                <div style={{ padding: 24, textAlign: 'center' }}>
                  <div className="spinner" style={{ width: 36, height: 36, border: '4px solid #e5e7eb', borderTop: '4px solid #22c55e', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }} />
                  <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }`}</style>
                </div>
              ) : notifications.length === 0 ? (
                <div style={{ padding: 48, textAlign: 'center', color: '#666' }}>
                  <FaBell size={48} style={{ marginBottom: 16, opacity: 0.5 }} />
                  <h3 style={{ marginBottom: 8, color: '#333' }}>No notifications yet</h3>
                  <p>Create your first notification to get started!</p>
                </div>
              ) : (
                <div style={{ width: '100%', overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0 }}>
                    <thead style={{ position: 'sticky', top: 0, zIndex: 2 }}>
                      <tr style={{ background: 'linear-gradient(90deg, #e0f7fa 0%, #f8fafc 100%)', color: '#222' }}>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Title</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Type</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Target</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Status</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Created</th>
                        <th style={{ padding: 16, textAlign: 'center', fontWeight: 700 }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notifications.map((notification, index) => (
                        <tr key={notification.id} style={{ 
                          background: index % 2 === 0 ? '#fff' : '#f8fafc',
                          transition: 'background 0.2s',
                        }}>
                          <td style={{ padding: 16 }}>
                            <div>
                              <div style={{ fontWeight: 600, color: '#333', marginBottom: 4 }}>
                                {notification.title}
                              </div>
                              <div style={{ fontSize: 14, color: '#666', lineHeight: 1.4 }}>
                                {notification.message.length > 100 
                                  ? `${notification.message.substring(0, 100)}...` 
                                  : notification.message}
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: 16 }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: 20,
                              fontSize: 12,
                              fontWeight: 600,
                              background: notification.type === 'job_update' ? '#dbeafe' : 
                                         notification.type === 'reward' ? '#fef3c7' :
                                         notification.type === 'announcement' ? '#e9d5ff' : '#e5e7eb',
                              color: notification.type === 'job_update' ? '#1d4ed8' :
                                     notification.type === 'reward' ? '#d97706' :
                                     notification.type === 'announcement' ? '#7c3aed' : '#6b7280',
                            }}>
                              {notification.type.replace('_', ' ').toUpperCase()}
                            </span>
                          </td>
                          <td style={{ padding: 16 }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: 20,
                              fontSize: 12,
                              fontWeight: 600,
                              background: notification.target_audience === 'all' ? '#dcfce7' :
                                         notification.target_audience === 'employed' ? '#dbeafe' : '#fef3c7',
                              color: notification.target_audience === 'all' ? '#166534' :
                                     notification.target_audience === 'employed' ? '#1d4ed8' : '#d97706',
                            }}>
                              {notification.target_audience.toUpperCase()}
                            </span>
                          </td>
                          <td style={{ padding: 16 }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: 20,
                              fontSize: 12,
                              fontWeight: 600,
                              background: notification.is_active ? '#dcfce7' : '#fee2e2',
                              color: notification.is_active ? '#166534' : '#991b1b',
                            }}>
                              {notification.is_active ? 'ACTIVE' : 'INACTIVE'}
                            </span>
                          </td>
                          <td style={{ padding: 16, fontSize: 14, color: '#666' }}>
                            {new Date(notification.created_at).toLocaleDateString()}
                          </td>
                          <td style={{ padding: 16, textAlign: 'center' }}>
                            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                              <button
                                onClick={() => handleSendNotification(notification.id)}
                                style={{
                                  padding: '6px 12px',
                                  borderRadius: 8,
                                  background: '#22c55e',
                                  color: '#fff',
                                  border: 'none',
                                  cursor: 'pointer',
                                  fontSize: 12,
                                  fontWeight: 600,
                                }}
                                title="Send Notification"
                              >
                                Send
                              </button>
                              <button
                                onClick={() => handleEditNotification(notification)}
                                style={{
                                  padding: '6px 12px',
                                  borderRadius: 8,
                                  background: '#3b82f6',
                                  color: '#fff',
                                  border: 'none',
                                  cursor: 'pointer',
                                  fontSize: 12,
                                  fontWeight: 600,
                                }}
                                title="Edit Notification"
                              >
                                Edit
                              </button>
                              <button
                                onClick={() => handleDeleteNotification(notification.id)}
                                style={{
                                  padding: '6px 12px',
                                  borderRadius: 8,
                                  background: '#ef4444',
                                  color: '#fff',
                                  border: 'none',
                                  cursor: 'pointer',
                                  fontSize: 12,
                                  fontWeight: 600,
                                }}
                                title="Delete Notification"
                              >
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}
        {tab === 'supervisors' && (
          <div style={{ marginTop: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 16 }}>
              <h2 style={{ color: '#22c55e', fontWeight: 700, margin: 0 }}>Supervisor Management</h2>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                <input
                  type="text"
                  placeholder="Search by name, email, mobile..."
                  value={supervisorSearch}
                  onChange={(e) => setSupervisorSearch(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') { setSupervisorPage(1); fetchSupervisors(); } }}
                  style={{
                    padding: '8px 14px',
                    borderRadius: 8,
                    border: '1px solid #e2e8f0',
                    fontSize: 14,
                    minWidth: 220
                  }}
                />
                <button
                  type="button"
                  className="gogig-card-btn-outline"
                  style={{ padding: '8px 16px' }}
                  onClick={() => { setSupervisorPage(1); fetchSupervisors(); }}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="gogig-card-btn-outline"
                  style={{ padding: '8px 16px', whiteSpace: 'nowrap' }}
                  onClick={async () => {
                    try {
                      const previewRes = await adminFetch(`${API_URL}/api/admin/supervisors/backfill-companies?dryRun=true`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({})
                      });
                      const preview = await previewRes.json();
                      if (!preview.success) {
                        toast.error(preview.message || 'Backfill preview failed');
                        return;
                      }
                      const lines = (preview.results || [])
                        .slice(0, 25)
                        .map((r) => `${r.name || r.email}: ${r.reason}${r.company ? ` → ${r.company.company_name}` : ''}`)
                        .join('\n');
                      const apply = window.confirm(
                        `Supervisors missing company: ${preview.totalMissing}\nWould update: ${preview.updated}\nNo match: ${preview.unmatched}\n\n${lines || '(none)'}\n\nApply these company assignments now?`
                      );
                      if (!apply) {
                        toast('Backfill cancelled');
                        return;
                      }
                      const applyRes = await adminFetch(`${API_URL}/api/admin/supervisors/backfill-companies`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({})
                      });
                      const applied = await applyRes.json();
                      if (applied.success) {
                        toast.success(`Saved company for ${applied.updated} supervisor(s). ${applied.unmatched} still unmatched.`);
                        fetchSupervisors();
                      } else {
                        toast.error(applied.message || 'Backfill failed');
                      }
                    } catch (err) {
                      console.error(err);
                      toast.error('Backfill failed');
                    }
                  }}
                >
                  Backfill Companies
                </button>
                <button
                  className="gogig-card-btn"
                  onClick={() => {
                    setShowSupervisorForm(true);
                    setEditingSupervisor(null);
                    setSupervisorForm({ name: '', email: '', mobile: '', password: '', role: 'supervisor', permissions: {}, spoc_id: '', company_id: '' });
                  }}
                >
                  Add Supervisor
                </button>
              </div>
            </div>
            
            {loading ? (
              <div style={{ textAlign: 'center', padding: 40 }}>
                <div className="spinner" style={{ width: 40, height: 40, border: '4px solid #e5e7eb', borderTop: '4px solid #22c55e', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }} />
              </div>
            ) : (
              <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(34,197,94,0.07)', border: '1.5px solid #e5e7eb', overflow: 'auto' }}>
                {supervisors.length > 0 ? (
                  <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0 }}>
                    <thead>
                      <tr style={{ background: 'linear-gradient(90deg, #e0f7fa 0%, #f8fafc 100%)', color: '#222' }}>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Name</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Email</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Mobile</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Company</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>SPOC</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Status</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Created</th>
                        <th style={{ padding: 16, textAlign: 'center', fontWeight: 700 }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {supervisors.map((supervisor, idx) => (
                        <tr key={supervisor.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                          <td style={{ padding: 16, fontWeight: 600 }}>{supervisor.name}</td>
                          <td style={{ padding: 16 }}>{supervisor.email}</td>
                          <td style={{ padding: 16 }}>{supervisor.mobile}</td>
                          <td style={{ padding: 16 }}>
                            {supervisor.company_name ? (
                              <span style={{
                                padding: '4px 12px',
                                borderRadius: 20,
                                fontSize: 12,
                                fontWeight: 600,
                                background: '#ecfdf5',
                                color: '#065f46'
                              }} title={supervisor.establishment_code || ''}>
                                {supervisor.company_name}
                              </span>
                            ) : (
                              <span style={{ color: '#dc2626', fontSize: 12, fontWeight: 600 }}>Not assigned</span>
                            )}
                          </td>
                          <td style={{ padding: 16 }}>
                            {supervisor.spoc ? (
                              <span style={{
                                padding: '4px 12px',
                                borderRadius: 20,
                                fontSize: 12,
                                fontWeight: 600,
                                background: '#dbeafe',
                                color: '#1e40af'
                              }}>
                                {supervisor.spoc.name}
                              </span>
                            ) : (
                              <span style={{ color: '#9ca3af', fontSize: 12 }}>Not assigned</span>
                            )}
                          </td>
                          <td style={{ padding: 16 }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: 20,
                              fontSize: 12,
                              fontWeight: 600,
                              background: supervisor.status === 'active' ? '#dcfce7' : '#fee2e2',
                              color: supervisor.status === 'active' ? '#166534' : '#991b1b'
                            }}>
                              {supervisor.status}
                            </span>
                          </td>
                          <td style={{ padding: 16, color: '#666' }}>
                            {new Date(supervisor.created_at).toLocaleDateString()}
                          </td>
                          <td style={{ padding: 16, textAlign: 'center' }}>
                            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
                              <button
                                className="gogig-card-btn-outline"
                                style={{ padding: '6px 12px', fontSize: 12 }}
                                onClick={() => handleEditSupervisor(supervisor)}
                              >
                                Edit
                              </button>
                              <button
                                className="gogig-card-btn-outline"
                                style={{ padding: '6px 12px', fontSize: 12, background: '#fef3c7', color: '#92400e', borderColor: '#92400e' }}
                                onClick={() => handleResetPasswordSupervisor(supervisor)}
                              >
                                Reset Password
                              </button>
                              <button
                                className="gogig-card-btn-outline"
                                style={{ padding: '6px 12px', fontSize: 12, background: '#fee2e2', color: '#991b1b', borderColor: '#991b1b' }}
                                onClick={() => handleDeleteSupervisor(supervisor.id)}
                              >
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div style={{ padding: 40, textAlign: 'center', color: '#666' }}>
                    No supervisors found. Create your first supervisor to get started.
                  </div>
                )}
              </div>
            )}
            {/* Supervisor pagination */}
            {tab === 'supervisors' && supervisorTotal > 0 && (
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 16,
                marginTop: 20,
                padding: '16px 20px',
                background: '#fff',
                borderRadius: 12,
                border: '1px solid #e2e8f0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
              }}>
                <span style={{ fontSize: 14, color: '#64748b' }}>
                  Showing {((supervisorPage - 1) * SUPERVISOR_PAGE_SIZE) + 1}–{Math.min(supervisorPage * SUPERVISOR_PAGE_SIZE, supervisorTotal)} of {supervisorTotal} supervisors
                </span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <button
                    type="button"
                    onClick={() => setSupervisorPage(p => Math.max(1, p - 1))}
                    disabled={supervisorPage <= 1}
                    style={{
                      padding: '8px 14px',
                      borderRadius: 8,
                      border: '1px solid #e2e8f0',
                      background: supervisorPage <= 1 ? '#f8fafc' : '#fff',
                      color: supervisorPage <= 1 ? '#94a3b8' : '#475569',
                      fontWeight: 500,
                      cursor: supervisorPage <= 1 ? 'not-allowed' : 'pointer',
                      fontSize: 14
                    }}
                  >
                    ‹ Previous
                  </button>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    {Array.from({ length: Math.min(5, supervisorTotalPages) }, (_, i) => {
                      let pageNum;
                      if (supervisorTotalPages <= 5) pageNum = i + 1;
                      else if (supervisorPage <= 3) pageNum = i + 1;
                      else if (supervisorPage >= supervisorTotalPages - 2) pageNum = supervisorTotalPages - 4 + i;
                      else pageNum = supervisorPage - 2 + i;
                      if (pageNum < 1) return null;
                      return (
                        <button
                          key={pageNum}
                          type="button"
                          onClick={() => setSupervisorPage(pageNum)}
                          style={{
                            minWidth: 36,
                            height: 36,
                            padding: '0 10px',
                            borderRadius: 8,
                            border: supervisorPage === pageNum ? 'none' : '1px solid #e2e8f0',
                            background: supervisorPage === pageNum ? 'linear-gradient(135deg, #22c55e 0%, #2ad2c9 100%)' : '#fff',
                            color: supervisorPage === pageNum ? '#fff' : '#475569',
                            fontWeight: supervisorPage === pageNum ? 600 : 500,
                            cursor: 'pointer',
                            fontSize: 14
                          }}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                  </div>
                  <button
                    type="button"
                    onClick={() => setSupervisorPage(p => Math.min(supervisorTotalPages, p + 1))}
                    disabled={supervisorPage >= supervisorTotalPages}
                    style={{
                      padding: '8px 14px',
                      borderRadius: 8,
                      border: '1px solid #e2e8f0',
                      background: supervisorPage >= supervisorTotalPages ? '#f8fafc' : '#fff',
                      color: supervisorPage >= supervisorTotalPages ? '#94a3b8' : '#475569',
                      fontWeight: 500,
                      cursor: supervisorPage >= supervisorTotalPages ? 'not-allowed' : 'pointer',
                      fontSize: 14
                    }}
                  >
                    Next ›
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
        {tab === 'jobs' && (
          <div style={{ marginTop: 32 }}>
            <h2 style={{ color: '#22c55e', fontWeight: 700, marginBottom: 18 }}>All Posted Jobs</h2>
            {loading ? <div>Loading...</div> : (
              <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 12 }}>
                <thead>
                  <tr style={{ background: '#f3f4f6' }}>
                    <th style={{ padding: 10, border: '1px solid #eee' }}>Job Title</th>
                    <th style={{ padding: 10, border: '1px solid #eee' }}>Company</th>
                    <th style={{ padding: 10, border: '1px solid #eee' }}>Location</th>
                    <th style={{ padding: 10, border: '1px solid #eee' }}>Stipend</th>
                    <th style={{ padding: 10, border: '1px solid #eee' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {jobs.map(job => (
                    <tr key={job.id}>
                      <td style={{ padding: 10, border: '1px solid #eee' }}>{job.title}</td>
                      <td style={{ padding: 10, border: '1px solid #eee' }}>{job.company_name}</td>
                      <td style={{ padding: 10, border: '1px solid #eee' }}>{job.location}</td>
                      <td style={{ padding: 10, border: '1px solid #eee' }}>₹{job.stipend_min} - ₹{job.stipend_max}</td>
                      <td style={{ padding: 10, border: '1px solid #eee' }}>
                        <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                          <button className="gogig-card-btn-outline" onClick={() => copyJobShareLink(job)}>Share Link</button>
                          <button className="gogig-card-btn-outline" onClick={() => fetchJobApplicants(job)}>View Applicants</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
        {/* Applicants Modal */}
        {showApplicantsModal && (
          <div className="gogig-modal-bg" onClick={() => setShowApplicantsModal(false)}>
            <div className="gogig-modal" style={{ minWidth: 340, maxWidth: 600 }} onClick={e => e.stopPropagation()}>
              <h3 style={{ color: '#22c55e', fontWeight: 700, fontSize: 22, marginBottom: 12 }}>Applicants for {selectedJob?.title}</h3>
              {jobApplicants.length === 0 ? <div style={{ color: '#888' }}>No applicants yet.</div> : (
                <>
                  <button className="gogig-card-btn" style={{ marginBottom: 16 }} onClick={() => {
                    // CSV header
                    const header = ['Name', 'Email', 'Mobile', 'Qualification', 'Course', 'Status'];
                    // CSV rows
                    const rows = jobApplicants.map(app => [
                      app.name || '',
                      app.email || '',
                      app.mobile || '',
                      app.qualification || '',
                      app.course || '',
                      app.status || ''
                    ]);
                    // CSV content
                    const csvContent = [header, ...rows].map(e => e.map(x => `"${String(x).replace(/"/g, '""')}"`).join(",")).join("\n");
                    // Download
                    const blob = new Blob([csvContent], { type: 'text/csv' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `applicants_${selectedJob?.title || 'job'}.csv`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                  }}>
                    Download CSV
                  </button>
                  <div style={{ maxHeight: 400, overflowY: 'auto', width: '100%' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8 }}>
                      <thead>
                        <tr style={{ background: '#f3f4f6' }}>
                          <th style={{ padding: 8, border: '1px solid #eee' }}>Name</th>
                          <th style={{ padding: 8, border: '1px solid #eee' }}>Email</th>
                          <th style={{ padding: 8, border: '1px solid #eee' }}>Mobile</th>
                          <th style={{ padding: 8, border: '1px solid #eee' }}>Qualification</th>
                          <th style={{ padding: 8, border: '1px solid #eee' }}>Course</th>
                          <th style={{ padding: 8, border: '1px solid #eee' }}>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {jobApplicants.map(app => (
                          <tr key={app.id}>
                            <td style={{ padding: 8, border: '1px solid #eee' }}>{app.name}</td>
                            <td style={{ padding: 8, border: '1px solid #eee' }}>{app.email}</td>
                            <td style={{ padding: 8, border: '1px solid #eee' }}>{app.mobile}</td>
                            <td style={{ padding: 8, border: '1px solid #eee' }}>{app.qualification}</td>
                            <td style={{ padding: 8, border: '1px solid #eee' }}>{app.course}</td>
                            <td style={{ padding: 8, border: '1px solid #eee' }}>{app.status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
              <button className="gogig-card-btn-outline" style={{ marginTop: 10 }} onClick={() => setShowApplicantsModal(false)}>Close</button>
            </div>
          </div>
        )}

        {/* Supervisor Form Modal */}
        {showSupervisorForm && (
          <div className="gogig-modal-bg" onClick={() => setShowSupervisorForm(false)}>
            <div className="gogig-modal" style={{ minWidth: 400, maxWidth: 500 }} onClick={e => e.stopPropagation()}>
              <h3 style={{ color: '#22c55e', fontWeight: 700, fontSize: 22, marginBottom: 20 }}>
                {editingSupervisor ? 'Edit Supervisor' : 'Add New Supervisor'}
              </h3>
              
              <form onSubmit={editingSupervisor ? handleUpdateSupervisor : handleCreateSupervisor}>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: '#333' }}>
                    Name *
                  </label>
                  <input
                    type="text"
                    value={supervisorForm.name}
                    onChange={(e) => setSupervisorForm({...supervisorForm, name: e.target.value})}
                    required
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e1e5e9',
                      borderRadius: 8,
                      fontSize: 16,
                      outline: 'none',
                      transition: 'border-color 0.3s',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#22c55e'}
                    onBlur={(e) => e.target.style.borderColor = '#e1e5e9'}
                  />
                </div>

                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: '#333' }}>
                    Email *
                  </label>
                  <input
                    type="email"
                    value={supervisorForm.email}
                    onChange={(e) => setSupervisorForm({...supervisorForm, email: e.target.value})}
                    required
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e1e5e9',
                      borderRadius: 8,
                      fontSize: 16,
                      outline: 'none',
                      transition: 'border-color 0.3s',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#22c55e'}
                    onBlur={(e) => e.target.style.borderColor = '#e1e5e9'}
                  />
                </div>

                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: '#333' }}>
                    Mobile *
                  </label>
                  <input
                    type="tel"
                    value={supervisorForm.mobile}
                    onChange={(e) => setSupervisorForm({...supervisorForm, mobile: e.target.value})}
                    required
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e1e5e9',
                      borderRadius: 8,
                      fontSize: 16,
                      outline: 'none',
                      transition: 'border-color 0.3s',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#22c55e'}
                    onBlur={(e) => e.target.style.borderColor = '#e1e5e9'}
                  />
                </div>

                {!editingSupervisor && (
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: '#333' }}>
                      Password *
                    </label>
                    <input
                      type="password"
                      value={supervisorForm.password}
                      onChange={(e) => setSupervisorForm({...supervisorForm, password: e.target.value})}
                      required
                      style={{
                        width: '100%',
                        padding: '12px 16px',
                        border: '2px solid #e1e5e9',
                        borderRadius: 8,
                        fontSize: 16,
                        outline: 'none',
                        transition: 'border-color 0.3s',
                        boxSizing: 'border-box'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#22c55e'}
                      onBlur={(e) => e.target.style.borderColor = '#e1e5e9'}
                    />
                  </div>
                )}

                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: '#333' }}>
                    Role *
                  </label>
                  <select
                    value={supervisorForm.role}
                    onChange={(e) => setSupervisorForm({...supervisorForm, role: e.target.value})}
                    required
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e1e5e9',
                      borderRadius: 8,
                      fontSize: 16,
                      outline: 'none',
                      transition: 'border-color 0.3s',
                      boxSizing: 'border-box',
                      background: '#fff'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#22c55e'}
                    onBlur={(e) => e.target.style.borderColor = '#e1e5e9'}
                  >
                    <option value="supervisor">Supervisor</option>
                    <option value="admin_supervisor">Admin Supervisor</option>
                  </select>
                </div>

                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: '#333' }}>
                    Establishment Name (Company) *
                  </label>
                  <CompanyDropdown
                    companies={companies}
                    value={supervisorForm.company_id}
                    onChange={(e) => setSupervisorForm({...supervisorForm, company_id: e.target.value})}
                    placeholder="Select Company"
                  />
                </div>

                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 600, color: '#333' }}>
                    Assign to SPOC (Optional)
                  </label>
                  <select
                    value={supervisorForm.spoc_id}
                    onChange={(e) => setSupervisorForm({...supervisorForm, spoc_id: e.target.value})}
                    style={{
                      width: '100%',
                      padding: '12px 16px',
                      border: '2px solid #e1e5e9',
                      borderRadius: 8,
                      fontSize: 16,
                      outline: 'none',
                      transition: 'border-color 0.3s',
                      boxSizing: 'border-box',
                      background: '#fff'
                    }}
                    onFocus={(e) => e.target.style.borderColor = '#22c55e'}
                    onBlur={(e) => e.target.style.borderColor = '#e1e5e9'}
                  >
                    <option value="">No SPOC Assignment</option>
                    {(spocsForDropdown.length ? spocsForDropdown : spocs).map(spoc => (
                      <option key={spoc.id} value={spoc.id}>
                        {spoc.name} ({spoc.email})
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                  <button
                    type="submit"
                    className="gogig-card-btn"
                    style={{ flex: 1 }}
                  >
                    {editingSupervisor ? 'Update Supervisor' : 'Create Supervisor'}
                  </button>
                  <button
                    type="button"
                    className="gogig-card-btn-outline"
                    onClick={() => setShowSupervisorForm(false)}
                    style={{ flex: 1 }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Reset Supervisor Password Modal */}
        {resetPasswordSupervisor && (
          <div
            className="gogig-modal-bg"
            onClick={() => setResetPasswordSupervisor(null)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 24,
              background: 'rgba(0,0,0,0.5)',
              backdropFilter: 'blur(4px)'
            }}
          >
            <div
              className="gogig-modal-card"
              onClick={(e) => e.stopPropagation()}
              style={{
                maxWidth: 440,
                width: '100%',
                borderRadius: 16,
                overflow: 'hidden',
                boxShadow: '0 24px 48px rgba(0,0,0,0.12), 0 8px 16px rgba(34, 197, 94, 0.08)',
                border: '1px solid rgba(34, 197, 94, 0.2)',
                background: '#fff'
              }}
            >
              {/* Header */}
              <div style={{
                background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                padding: '24px 24px 20px',
                textAlign: 'center',
                color: '#fff'
              }}>
                <div style={{
                  width: 56,
                  height: 56,
                  borderRadius: '50%',
                  background: 'rgba(255,255,255,0.25)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 12
                }}>
                  <FaLock size={28} />
                </div>
                <h3 style={{ margin: 0, fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em' }}>Reset Password</h3>
                <p style={{ margin: '8px 0 0', fontSize: 14, opacity: 0.95 }}>Set a new password for this supervisor</p>
              </div>

              {/* User info card */}
              <div style={{
                margin: '20px 24px 0',
                padding: '14px 16px',
                borderRadius: 12,
                background: '#f8fafc',
                border: '1px solid #e2e8f0',
                display: 'flex',
                alignItems: 'center',
                gap: 12
              }}>
                <div style={{
                  width: 44,
                  height: 44,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #22c55e22 0%, #16a34a22 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#16a34a',
                  flexShrink: 0
                }}>
                  <FaUser size={20} />
                </div>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 600, color: '#1e293b', fontSize: 15 }}>{resetPasswordSupervisor.name}</div>
                  <div style={{ fontSize: 13, color: '#64748b', marginTop: 2 }}>{resetPasswordSupervisor.email}</div>
                </div>
              </div>

              <form onSubmit={handleSubmitResetPassword} style={{ padding: 24 }}>
                <div style={{ marginBottom: 18 }}>
                  <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, color: '#334155', fontSize: 14 }}>New password</label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type={showResetPasswordNew ? 'text' : 'password'}
                      value={resetPasswordNew}
                      onChange={(e) => setResetPasswordNew(e.target.value)}
                      placeholder="Enter new password (min 6 characters)"
                      minLength={6}
                      required
                      style={{
                        width: '100%',
                        padding: '12px 44px 12px 16px',
                        border: '2px solid #e2e8f0',
                        borderRadius: 10,
                        fontSize: 15,
                        outline: 'none',
                        boxSizing: 'border-box',
                        transition: 'border-color 0.2s'
                      }}
                      onFocus={(e) => { e.target.style.borderColor = '#22c55e'; }}
                      onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowResetPasswordNew(!showResetPasswordNew)}
                      style={{
                        position: 'absolute',
                        right: 12,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        color: '#64748b',
                        cursor: 'pointer',
                        padding: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      aria-label={showResetPasswordNew ? 'Hide password' : 'Show password'}
                    >
                      {showResetPasswordNew ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                    </button>
                  </div>
                  <div style={{ fontSize: 12, color: '#94a3b8', marginTop: 6 }}>Minimum 6 characters</div>
                </div>

                <div style={{ marginBottom: 24 }}>
                  <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, color: '#334155', fontSize: 14 }}>Confirm password</label>
                  <div style={{ position: 'relative' }}>
                    <input
                      type={showResetPasswordConfirm ? 'text' : 'password'}
                      value={resetPasswordConfirm}
                      onChange={(e) => setResetPasswordConfirm(e.target.value)}
                      placeholder="Re-enter new password"
                      minLength={6}
                      required
                      style={{
                        width: '100%',
                        padding: '12px 44px 12px 16px',
                        border: `2px solid ${resetPasswordConfirm && resetPasswordNew !== resetPasswordConfirm ? '#f87171' : '#e2e8f0'}`,
                        borderRadius: 10,
                        fontSize: 15,
                        outline: 'none',
                        boxSizing: 'border-box',
                        transition: 'border-color 0.2s'
                      }}
                      onFocus={(e) => { e.target.style.borderColor = resetPasswordNew !== resetPasswordConfirm ? '#f87171' : '#22c55e'; }}
                      onBlur={(e) => { e.target.style.borderColor = resetPasswordNew !== resetPasswordConfirm ? '#f87171' : '#e2e8f0'; }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowResetPasswordConfirm(!showResetPasswordConfirm)}
                      style={{
                        position: 'absolute',
                        right: 12,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        color: '#64748b',
                        cursor: 'pointer',
                        padding: 4,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      aria-label={showResetPasswordConfirm ? 'Hide password' : 'Show password'}
                    >
                      {showResetPasswordConfirm ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                    </button>
                  </div>
                  {resetPasswordConfirm && resetPasswordNew !== resetPasswordConfirm && (
                    <div style={{ fontSize: 12, color: '#dc2626', marginTop: 6 }}>Passwords do not match</div>
                  )}
                  {resetPasswordConfirm && resetPasswordNew === resetPasswordConfirm && resetPasswordNew.length >= 6 && (
                    <div style={{ fontSize: 12, color: '#22c55e', marginTop: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                      <FaCheckCircle size={14} /> Passwords match
                    </div>
                  )}
                </div>

                <div style={{ display: 'flex', gap: 12 }}>
                  <button
                    type="submit"
                    className="gogig-card-btn"
                    style={{
                      flex: 1,
                      padding: '14px 20px',
                      fontSize: 16,
                      fontWeight: 600,
                      borderRadius: 10,
                      background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
                      border: 'none',
                      color: '#fff',
                      cursor: 'pointer',
                      boxShadow: '0 4px 14px rgba(34, 197, 94, 0.35)',
                      transition: 'transform 0.15s, box-shadow 0.15s'
                    }}
                    onMouseOver={(e) => { e.target.style.transform = 'translateY(-1px)'; e.target.style.boxShadow = '0 6px 20px rgba(34, 197, 94, 0.4)'; }}
                    onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = '0 4px 14px rgba(34, 197, 94, 0.35)'; }}
                  >
                    Reset Password
                  </button>
                  <button
                    type="button"
                    className="gogig-card-btn-outline"
                    onClick={() => setResetPasswordSupervisor(null)}
                    style={{
                      flex: 1,
                      padding: '14px 20px',
                      fontSize: 16,
                      fontWeight: 600,
                      borderRadius: 10,
                      border: '2px solid #e2e8f0',
                      background: '#fff',
                      color: '#64748b',
                      cursor: 'pointer',
                      transition: 'border-color 0.2s, color 0.2s'
                    }}
                    onMouseOver={(e) => { e.target.style.borderColor = '#94a3b8'; e.target.style.color = '#475569'; }}
                    onMouseOut={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.color = '#64748b'; }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* SPOC Management */}
        {tab === 'spocs' && (
          <div style={{ marginTop: 32 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 16 }}>
              <h2 style={{ color: '#8b5cf6', fontWeight: 700, margin: 0 }}>SPOC Management</h2>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                <input
                  type="text"
                  placeholder="Search by name, email..."
                  value={spocSearch}
                  onChange={(e) => setSpocSearch(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') { setSpocPage(1); fetchSPOCs(); } }}
                  style={{
                    padding: '8px 14px',
                    borderRadius: 8,
                    border: '1px solid #e2e8f0',
                    fontSize: 14,
                    minWidth: 200
                  }}
                />
                <button
                  type="button"
                  className="gogig-card-btn-outline"
                  style={{ padding: '8px 16px' }}
                  onClick={() => { setSpocPage(1); fetchSPOCs(); }}
                >
                  Search
                </button>
                <button
                  className="gogig-card-btn"
                  onClick={async () => {
                    setShowSPOCForm(true);
                    setEditingSPOC(null);
                    setSpocForm({ name: '', email: '', password: '', company_ids: [] });
                    setSpocCompanySearch('');
                    // Fetch all SPOCs to get assigned company IDs, then companies for selection
                    try {
                      const [spocRes, companiesRes] = await Promise.all([
                        adminFetch(`${API_URL}/api/admin/spocs?page=1&limit=10000&search=`),
                        adminFetch(`${API_URL}/api/admin/companies?page=1&limit=1000&search=`)
                      ]);
                      const spocData = await spocRes.json();
                      const data = await companiesRes.json();
                      if (data.success) {
                        const allAssignedCompanyIds = new Set();
                        (spocData.success && (spocData.spocs || [])).forEach(s => {
                          if (s.company_ids) {
                            s.company_ids.forEach(id => allAssignedCompanyIds.add(id));
                          }
                        });
                        const availableCompanies = data.companies.filter(company =>
                          !allAssignedCompanyIds.has(company.id)
                        );
                        setCompanies(availableCompanies);
                      }
                    } catch (error) {
                      console.error('Error fetching companies:', error);
                    }
                  }}
                >
                  Add SPOC
                </button>
              </div>
            </div>
            
            {loading ? (
              <div style={{ textAlign: 'center', padding: 40 }}>
                <div className="spinner" style={{ width: 40, height: 40, border: '4px solid #e5e7eb', borderTop: '4px solid #8b5cf6', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }} />
              </div>
            ) : (
              <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 2px 16px rgba(139,92,246,0.07)', border: '1.5px solid #e5e7eb', overflow: 'auto' }}>
                {spocs.length > 0 ? (
                  <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0 }}>
                    <thead>
                      <tr style={{ background: 'linear-gradient(90deg, #f3e8ff 0%, #f8fafc 100%)', color: '#222' }}>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Name</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Email</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Companies</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Status</th>
                        <th style={{ padding: 16, textAlign: 'left', fontWeight: 700 }}>Created</th>
                        <th style={{ padding: 16, textAlign: 'center', fontWeight: 700 }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {spocs.map((spoc, idx) => (
                        <tr key={spoc.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                          <td style={{ padding: 16, fontWeight: 600 }}>{spoc.name}</td>
                          <td style={{ padding: 16 }}>{spoc.email}</td>
                          <td style={{ padding: 16 }}>
                            {spoc.company_ids && spoc.company_ids.length > 0 ? (
                              <span style={{ 
                                background: '#f3e8ff', 
                                color: '#8b5cf6', 
                                padding: '4px 8px', 
                                borderRadius: 6, 
                                fontSize: 12, 
                                fontWeight: 600 
                              }}>
                                {spoc.company_ids.length} companies
                              </span>
                            ) : (
                              <span style={{ color: '#9ca3af' }}>No companies</span>
                            )}
                          </td>
                          <td style={{ padding: 16 }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: 20,
                              fontSize: 12,
                              fontWeight: 600,
                              background: spoc.is_active ? '#dcfce7' : '#fef3c7',
                              color: spoc.is_active ? '#166534' : '#92400e'
                            }}>
                              {spoc.is_active ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td style={{ padding: 16, color: '#6b7280' }}>
                            {new Date(spoc.created_at).toLocaleDateString()}
                          </td>
                          <td style={{ padding: 16, textAlign: 'center' }}>
                            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
                              <button
                                onClick={() => handleEditSPOC(spoc)}
                                style={{
                                  background: '#3b82f6',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 6,
                                  padding: '6px 12px',
                                  fontSize: 12,
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 4
                                }}
                              >
                                <FaEdit />
                                Edit
                              </button>
                              <button
                                onClick={() => handleDeleteSPOC(spoc.id)}
                                style={{
                                  background: '#ef4444',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 6,
                                  padding: '6px 12px',
                                  fontSize: 12,
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 4
                                }}
                              >
                                <FaTrash />
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div style={{ textAlign: 'center', padding: 40, color: '#6b7280' }}>
                    <div style={{ fontSize: 48, marginBottom: 16 }}>👥</div>
                    <p>No SPOCs found</p>
                  </div>
                )}
              </div>
            )}
            {/* SPOC pagination */}
            {tab === 'spocs' && spocTotal > 0 && (
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 16,
                marginTop: 20,
                padding: '16px 20px',
                background: '#fff',
                borderRadius: 12,
                border: '1px solid #e2e8f0',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)'
              }}>
                <span style={{ fontSize: 14, color: '#64748b' }}>
                  Showing {((spocPage - 1) * SPOC_PAGE_SIZE) + 1}–{Math.min(spocPage * SPOC_PAGE_SIZE, spocTotal)} of {spocTotal} SPOCs
                </span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <button
                    type="button"
                    onClick={() => setSpocPage(p => Math.max(1, p - 1))}
                    disabled={spocPage <= 1}
                    style={{
                      padding: '8px 14px',
                      borderRadius: 8,
                      border: '1px solid #e2e8f0',
                      background: spocPage <= 1 ? '#f8fafc' : '#fff',
                      color: spocPage <= 1 ? '#94a3b8' : '#475569',
                      fontWeight: 500,
                      cursor: spocPage <= 1 ? 'not-allowed' : 'pointer',
                      fontSize: 14
                    }}
                  >
                    ‹ Previous
                  </button>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    {Array.from({ length: Math.min(5, spocTotalPages) }, (_, i) => {
                      let pageNum;
                      if (spocTotalPages <= 5) pageNum = i + 1;
                      else if (spocPage <= 3) pageNum = i + 1;
                      else if (spocPage >= spocTotalPages - 2) pageNum = spocTotalPages - 4 + i;
                      else pageNum = spocPage - 2 + i;
                      if (pageNum < 1) return null;
                      return (
                        <button
                          key={pageNum}
                          type="button"
                          onClick={() => setSpocPage(pageNum)}
                          style={{
                            minWidth: 36,
                            height: 36,
                            padding: '0 10px',
                            borderRadius: 8,
                            border: spocPage === pageNum ? 'none' : '1px solid #e2e8f0',
                            background: spocPage === pageNum ? 'linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%)' : '#fff',
                            color: spocPage === pageNum ? '#fff' : '#475569',
                            fontWeight: spocPage === pageNum ? 600 : 500,
                            cursor: 'pointer',
                            fontSize: 14
                          }}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                  </div>
                  <button
                    type="button"
                    onClick={() => setSpocPage(p => Math.min(spocTotalPages, p + 1))}
                    disabled={spocPage >= spocTotalPages}
                    style={{
                      padding: '8px 14px',
                      borderRadius: 8,
                      border: '1px solid #e2e8f0',
                      background: spocPage >= spocTotalPages ? '#f8fafc' : '#fff',
                      color: spocPage >= spocTotalPages ? '#94a3b8' : '#475569',
                      fontWeight: 500,
                      cursor: spocPage >= spocTotalPages ? 'not-allowed' : 'pointer',
                      fontSize: 14
                    }}
                  >
                    Next ›
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* SPOC Form Modal */}
        {showSPOCForm && (
          <div className="gogig-modal-bg" onClick={() => setShowSPOCForm(false)}>
            <div className="gogig-modal" onClick={e => e.stopPropagation()}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                <h3 style={{ color: '#8b5cf6', fontWeight: 700, margin: 0 }}>
                  {editingSPOC ? 'Edit SPOC' : 'Add New SPOC'}
                </h3>
                <button
                  onClick={() => setShowSPOCForm(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontSize: 24,
                    cursor: 'pointer',
                    color: '#6b7280'
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              <form onSubmit={handleSPOCSubmit}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, color: '#374151' }}>
                      Name *
                    </label>
                    <input
                      type="text"
                      value={spocForm.name}
                      onChange={e => setSpocForm({ ...spocForm, name: e.target.value })}
                      required
                      style={{
                        width: '100%',
                        padding: 12,
                        border: '2px solid #e5e7eb',
                        borderRadius: 8,
                        fontSize: 14,
                        outline: 'none',
                        transition: 'border-color 0.2s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#8b5cf6'}
                      onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, color: '#374151' }}>
                      Email *
                    </label>
                    <input
                      type="email"
                      value={spocForm.email}
                      onChange={e => setSpocForm({ ...spocForm, email: e.target.value })}
                      required
                      style={{
                        width: '100%',
                        padding: 12,
                        border: '2px solid #e5e7eb',
                        borderRadius: 8,
                        fontSize: 14,
                        outline: 'none',
                        transition: 'border-color 0.2s ease'
                      }}
                      onFocus={(e) => e.target.style.borderColor = '#8b5cf6'}
                      onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                    />
                  </div>

                  {!editingSPOC && (
                    <div>
                      <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, color: '#374151' }}>
                        Password *
                      </label>
                      <input
                        type="password"
                        value={spocForm.password}
                        onChange={e => setSpocForm({ ...spocForm, password: e.target.value })}
                        required
                        style={{
                          width: '100%',
                          padding: 12,
                          border: '2px solid #e5e7eb',
                          borderRadius: 8,
                          fontSize: 14,
                          outline: 'none',
                          transition: 'border-color 0.2s ease'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#8b5cf6'}
                        onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                      />
                    </div>
                  )}

                  <div>
                    <label style={{ display: 'block', marginBottom: 8, fontWeight: 600, color: '#374151' }}>
                      Assign Companies
                    </label>
                    {/* Search bar for companies */}
                    <div style={{ marginBottom: 12, position: 'relative' }}>
                      <FaSearch style={{ 
                        position: 'absolute', 
                        left: 12, 
                        top: '50%', 
                        transform: 'translateY(-50%)', 
                        color: '#9ca3af',
                        fontSize: 14
                      }} />
                      <input
                        type="text"
                        placeholder="Search companies..."
                        value={spocCompanySearch}
                        onChange={e => setSpocCompanySearch(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '10px 12px 10px 36px',
                          border: '2px solid #e5e7eb',
                          borderRadius: 8,
                          fontSize: 14,
                          outline: 'none',
                          transition: 'border-color 0.2s ease'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#8b5cf6'}
                        onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                      />
                    </div>
                    <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 8, padding: 8 }}>
                      {companies.length > 0 ? (
                        (() => {
                          const filteredCompanies = companies.filter(company =>
                            company.company_name.toLowerCase().includes(spocCompanySearch.toLowerCase())
                          );
                          
                          // Sort: selected companies first, then unselected
                          const sortedCompanies = filteredCompanies.sort((a, b) => {
                            const aSelected = spocForm.company_ids.includes(a.id);
                            const bSelected = spocForm.company_ids.includes(b.id);
                            if (aSelected && !bSelected) return -1;
                            if (!aSelected && bSelected) return 1;
                            // If both selected or both unselected, sort alphabetically
                            return a.company_name.localeCompare(b.company_name);
                          });
                          
                          return sortedCompanies.length > 0 ? (
                            sortedCompanies.map(company => {
                              const isSelected = spocForm.company_ids.includes(company.id);
                              return (
                                <label key={company.id} style={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  gap: 8, 
                                  padding: '8px 0', 
                                  cursor: 'pointer',
                                  background: isSelected ? '#f0f9ff' : 'transparent',
                                  borderRadius: 4,
                                  paddingLeft: '8px',
                                  paddingRight: '8px'
                                }}>
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={e => {
                                      if (e.target.checked) {
                                        setSpocForm({ ...spocForm, company_ids: [...spocForm.company_ids, company.id] });
                                      } else {
                                        setSpocForm({ ...spocForm, company_ids: spocForm.company_ids.filter(id => id !== company.id) });
                                      }
                                    }}
                                  />
                                  <span style={{ fontSize: 14, fontWeight: isSelected ? 600 : 400 }}>{company.company_name}</span>
                                </label>
                              );
                            })
                          ) : (
                            <div style={{ padding: '16px', textAlign: 'center', color: '#6b7280' }}>
                              No companies found matching "{spocCompanySearch}"
                            </div>
                          );
                        })()
                      ) : (
                        <div style={{ padding: '16px', textAlign: 'center', color: '#6b7280' }}>
                          Loading companies...
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                  <button
                    type="submit"
                    className="gogig-card-btn"
                    style={{ flex: 1 }}
                  >
                    {editingSPOC ? 'Update SPOC' : 'Create SPOC'}
                  </button>
                  <button
                    type="button"
                    className="gogig-card-btn-outline"
                    onClick={() => setShowSPOCForm(false)}
                    style={{ flex: 1 }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Details Modal */}
        {showDetailsModal && selectedItemDetails && (
          <div 
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
            onClick={() => setShowDetailsModal(false)}
          >
            <div 
              style={{
                background: '#fff',
                borderRadius: 16,
                padding: 24,
                maxWidth: '80vw',
                maxHeight: '80vh',
                overflow: 'auto',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
                position: 'relative'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={() => setShowDetailsModal(false)}
                style={{
                  position: 'absolute',
                  top: 16,
                  right: 16,
                  background: 'none',
                  border: 'none',
                  fontSize: 24,
                  cursor: 'pointer',
                  color: '#666',
                  padding: 4,
                  borderRadius: 4
                }}
              >
                ×
              </button>

              {/* Modal Header */}
              <div style={{ marginBottom: 24, paddingRight: 40 }}>
                <h3 style={{ 
                  fontSize: 24, 
                  fontWeight: 700, 
                  color: '#374151', 
                  margin: 0,
                  marginBottom: 8
                }}>
                  Additional Details
                </h3>
                <p style={{ 
                  fontSize: 16, 
                  color: '#6b7280', 
                  margin: 0 
                }}>
                  {selectedItemDetails.name || selectedItemDetails.company_name}
                </p>
              </div>

              {/* Details Content */}
              <div style={{ 
                background: '#f8fafc', 
                borderRadius: 12, 
                padding: 20,
                border: '1px solid #e5e7eb'
              }}>
                {selectedItemDetails.additional_details ? (
                  (() => {
                    try {
                      const details = typeof selectedItemDetails.additional_details === 'string' 
                        ? JSON.parse(selectedItemDetails.additional_details) 
                        : selectedItemDetails.additional_details;
                      
                      if (Object.keys(details).length > 0) {
                        return (
                          <div style={{ 
                            display: 'grid', 
                            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
                            gap: 16 
                          }}>
                            {Object.entries(details).map(([key, value]) => (
                              <div key={key} style={{
                                background: '#fff',
                                padding: 16,
                                borderRadius: 8,
                                border: '1px solid #e5e7eb',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
                              }}>
                                <div style={{ 
                                  fontSize: 12, 
                                  fontWeight: 600, 
                                  color: '#6b7280', 
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.5px',
                                  marginBottom: 4
                                }}>
                                  {key.replace(/_/g, ' ')}
                                </div>
                                <div style={{ 
                                  fontSize: 14, 
                                  color: '#374151',
                                  fontWeight: 500
                                }}>
                                  {value || '-'}
                                </div>
                              </div>
                            ))}
                          </div>
                        );
                      } else {
                        return (
                          <div style={{ 
                            textAlign: 'center', 
                            color: '#6b7280', 
                            padding: 40,
                            fontSize: 16
                          }}>
                            No additional details available
                          </div>
                        );
                      }
                    } catch (e) {
                      return (
                        <div style={{ 
                          textAlign: 'center', 
                          color: '#ef4444', 
                          padding: 40,
                          fontSize: 16
                        }}>
                          Error parsing additional details
                        </div>
                      );
                    }
                  })()
                ) : (
                  <div style={{ 
                    textAlign: 'center', 
                    color: '#6b7280', 
                    padding: 40,
                    fontSize: 16
                  }}>
                    No additional details available
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div style={{ 
                marginTop: 24, 
                display: 'flex', 
                justifyContent: 'flex-end' 
              }}>
                <button
                  onClick={() => setShowDetailsModal(false)}
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 8,
                    padding: '12px 24px',
                    fontSize: 14,
                    fontWeight: 600,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 8px rgba(102, 126, 234, 0.3)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = 'none';
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default AdminDashboard; 